// The Riddle Box. An original deck. A set deals twelve of the 240.

const TITLE = "The Riddle Box";
const DEK = "Twelve riddles from a box of 240. Each one has one answer.";

const introParagraphs = [
  "Twelve riddles were drawn from the box. They are numbered for this set only.",
  "Each riddle has one answer. The answers are not printed in this file.",
];

const SLIPS = [
  {
    id: "buoys",
    difficulty: "easy",
    title: "Three buoys",
    text: "Three buoys mark the channel. The red buoy is north of the green buoy. The black buoy is north of the red buoy. Which buoy is farthest south?",
    answer: "The green buoy.",
    accept: ["the green buoy", "green buoy", "green"],
    correct: "green",
    options: [
      { id: "red", label: "The red buoy" },
      { id: "black", label: "The black buoy" },
      { id: "green", label: "The green buoy" },
    ],
  },
  {
    id: "coat",
    difficulty: "easy",
    title: "Two coats",
    text: "Two coats hang on one peg in the rain. The oiled cloth is hung over the wool. Which coat stays dry?",
    answer: "The wool coat.",
    accept: ["the wool coat", "wool coat", "the wool", "wool"],
    correct: "wool",
    options: [
      { id: "oiled", label: "The oiled cloth" },
      { id: "wool", label: "The wool coat" },
    ],
  },
  {
    id: "fork",
    difficulty: "easy",
    title: "The right fork",
    text: "The left fork goes to the pier. The right fork goes to the pier when it is raining, and to the road when it is not. It is not raining. You take the right fork. Where do you arrive?",
    answer: "The road.",
    accept: ["the road", "road"],
    correct: "road",
    options: [
      { id: "pier", label: "The pier" },
      { id: "road", label: "The road" },
    ],
  },
  {
    id: "shed",
    difficulty: "easy",
    title: "Leaving the shed",
    text: "Ada, Bess, Cole, and Dana leave the shed one minute apart. Ada leaves first. Cole leaves last. Bess leaves after Dana. Who leaves second?",
    answer: "Dana.",
    accept: ["dana"],
    correct: "dana",
    options: [
      { id: "ada", label: "Ada" },
      { id: "bess", label: "Bess" },
      { id: "cole", label: "Cole" },
      { id: "dana", label: "Dana" },
    ],
  },
  {
    id: "hook",
    difficulty: "easy",
    title: "Four hooks",
    text: "Four hooks in a row hold one key. The key is not on either end hook. It is not on the second hook. Which hook is it on?",
    answer: "The third hook.",
    accept: ["the third hook", "third hook", "the third", "third", "3", "hook 3"],
    correct: "third",
    options: [
      { id: "first", label: "The first hook" },
      { id: "second", label: "The second hook" },
      { id: "third", label: "The third hook" },
      { id: "fourth", label: "The fourth hook" },
    ],
  },
  {
    id: "clock",
    difficulty: "medium",
    title: "The slow clock",
    text: "A clock loses ten minutes every true hour. It is set right at noon. What time does it show when the true time is six in the evening?",
    answer: "5:00.",
    accept: ["5:00", "5.00", "500", "5 o'clock", "5 oclock", "five o'clock", "five oclock"],
    correct: "five",
    options: [
      { id: "four", label: "4:00" },
      { id: "five", label: "5:00" },
      { id: "six", label: "6:00" },
      { id: "eight", label: "8:00" },
    ],
  },
  {
    id: "bell",
    difficulty: "medium",
    title: "The harbour bell",
    text: "The harbour bell rings once on each hour and once at each half hour. Count the rings from the noon ring up to, but not including, the midnight ring. How many rings is that?",
    answer: "24.",
    accept: ["24", "twenty-four", "twenty four"],
    correct: "24",
    options: [
      { id: "12", label: "12" },
      { id: "24", label: "24" },
      { id: "25", label: "25" },
      { id: "48", label: "48" },
    ],
  },
  {
    id: "tide",
    difficulty: "medium",
    title: "The tide book",
    text: "The tide book lists high water at 3, then at 4, then at 6, then at 9. Each gap is one hour longer than the gap before it. What number comes next?",
    answer: "13.",
    accept: ["13", "thirteen"],
    correct: "13",
    options: [
      { id: "12", label: "12" },
      { id: "13", label: "13" },
      { id: "14", label: "14" },
      { id: "15", label: "15" },
    ],
  },
  {
    id: "window",
    difficulty: "medium",
    title: "The open window",
    text: "The store has a north window and a south window. The north window is stuck shut. The lamp stays lit only while every window is shut, and the lamp is out. Which window is open?",
    answer: "The south window.",
    accept: ["the south window", "south window", "south"],
    correct: "south",
    options: [
      { id: "north", label: "The north window" },
      { id: "south", label: "The south window" },
    ],
  },
  {
    id: "watch",
    difficulty: "hard",
    title: "The dawn watch",
    text: "Mina, Paul, and Ruth take the dusk, night, and dawn watches, one each. Mina does not take dawn. Paul does not take dusk. Paul does not take night. Who takes the dawn watch?",
    answer: "Paul.",
    accept: ["paul"],
    correct: "paul",
    options: [
      { id: "mina", label: "Mina" },
      { id: "paul", label: "Paul" },
      { id: "ruth", label: "Ruth" },
    ],
  },
  {
    id: "tin",
    difficulty: "hard",
    title: "The fuel tin",
    text: "A full tin runs the generator for 8 hours. The tin is one third full. How long will the generator run?",
    answer: "2 hours 40 minutes.",
    accept: ["2 hours 40 minutes", "2 hours and 40 minutes", "two hours 40 minutes", "two hours and forty minutes", "160 minutes", "2hrs 40min"],
    correct: "2h40",
    options: [
      { id: "2h", label: "2 hours" },
      { id: "2h40", label: "2 hours 40 minutes" },
      { id: "4h", label: "4 hours" },
      { id: "8h", label: "8 hours" },
    ],
  },
  {
    id: "shadow",
    difficulty: "hard",
    title: "The post's shadow",
    text: "A post throws a shadow as long as itself. Later that morning the shadow is only half as long as the post. Which shadow is closer to noon, the long one or the short one?",
    answer: "The short one.",
    accept: ["the short one", "short one", "the short shadow", "short"],
    correct: "short",
    options: [
      { id: "long", label: "The long one" },
      { id: "short", label: "The short one" },
    ],
  },
  {
    id: "door",
    difficulty: "easy",
    title: "The shed door",
    text: "The shed door is green on the outside and red on the inside. You are in the shed. What colour is the side of the door you can see?",
    answer: "Red.",
    accept: ["red"],
    correct: "red",
    options: [
      { id: "green", label: "Green" },
      { id: "red", label: "Red" },
    ],
  },
  {
    id: "oar",
    difficulty: "easy",
    title: "The short oar",
    text: "Two oars hang on the rack. The long oar is on the left. Which side is the short oar on?",
    answer: "The right.",
    accept: ["the right", "right"],
    correct: "right",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "steps",
    difficulty: "easy",
    title: "The quay steps",
    text: "Six steps lead up from the boat. You are standing on step 4, counting from the bottom. How many steps are above you?",
    answer: "2.",
    accept: ["2", "two"],
    correct: "2",
    options: [
      { id: "2", label: "2" },
      { id: "4", label: "4" },
      { id: "6", label: "6" },
    ],
  },
  {
    id: "ferry",
    difficulty: "medium",
    title: "The next ferry",
    text: "The ferry leaves every 20 minutes, starting at nine. You arrive at a quarter to ten. When is the next ferry?",
    answer: "10:00.",
    accept: ["10:00", "10", "ten"],
    correct: "ten",
    options: [
      { id: "nineforty", label: "9:40" },
      { id: "ten", label: "10:00" },
      { id: "tentwenty", label: "10:20" },
    ],
  },
  {
    id: "rope",
    difficulty: "medium",
    title: "The cut rope",
    text: "A rope is cut into three equal pieces. How many cuts does that take?",
    answer: "2.",
    accept: ["2", "two"],
    correct: "2",
    options: [
      { id: "1", label: "1" },
      { id: "2", label: "2" },
      { id: "3", label: "3" },
    ],
  },
  {
    id: "corks",
    difficulty: "medium",
    title: "The corks",
    text: "A net has 4 rows, and each row has 5 corks. How many corks is that?",
    answer: "20.",
    accept: ["20", "twenty"],
    correct: "20",
    options: [
      { id: "9", label: "9" },
      { id: "15", label: "15" },
      { id: "20", label: "20" },
    ],
  },
  {
    id: "passage",
    difficulty: "medium",
    title: "The passage",
    text: "The passage is 12 paces long. You walk 5 paces in, then 2 paces back, then 5 paces in again. How many paces are you from the start?",
    answer: "8.",
    accept: ["8", "eight"],
    correct: "8",
    options: [
      { id: "5", label: "5" },
      { id: "8", label: "8" },
      { id: "10", label: "10" },
      { id: "12", label: "12" },
    ],
  },
  {
    id: "crate",
    difficulty: "hard",
    title: "The empty crate",
    text: "A crate and its nails weigh 30 pounds together. The nails weigh twice as much as the empty crate. How much does the empty crate weigh?",
    answer: "10 pounds.",
    accept: ["10", "10 pounds", "ten pounds"],
    correct: "10",
    options: [
      { id: "10", label: "10 pounds" },
      { id: "15", label: "15 pounds" },
      { id: "20", label: "20 pounds" },
      { id: "30", label: "30 pounds" },
    ],
  },
  {
    id: "candles",
    difficulty: "hard",
    title: "The two candles",
    text: "One candle burns for 4 hours. The other burns for 6 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "2 hours.",
    accept: ["2 hours", "2", "two hours"],
    correct: "2h",
    options: [
      { id: "2h", label: "2 hours" },
      { id: "4h", label: "4 hours" },
      { id: "6h", label: "6 hours" },
      { id: "10h", label: "10 hours" },
    ],
  },
  {
    id: "posts",
    difficulty: "hard",
    title: "The evening post",
    text: "Lena, Omar, and Nia take the morning, noon, and evening posts, one each. Omar takes neither morning nor evening. Lena does not take morning. Who takes the evening post?",
    answer: "Lena.",
    accept: ["lena"],
    correct: "lena",
    options: [
      { id: "lena", label: "Lena" },
      { id: "omar", label: "Omar" },
      { id: "nia", label: "Nia" },
    ],
  },
  {
    id: "pump",
    difficulty: "hard",
    title: "The pump and the leak",
    text: "A pump fills the tank in 6 hours. A leak empties a full tank in 12 hours. The pump runs while the leak stays open. How long to fill the tank?",
    answer: "12 hours.",
    accept: ["12 hours", "12", "twelve hours"],
    correct: "12h",
    options: [
      { id: "6h", label: "6 hours" },
      { id: "9h", label: "9 hours" },
      { id: "12h", label: "12 hours" },
      { id: "18h", label: "18 hours" },
    ],
  },
  {
    id: "meal",
    difficulty: "hard",
    title: "The meal",
    text: "Four days' wages are 12 coins. The same four days can be paid as 2 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "1 coin.",
    accept: ["1", "1 coin", "one coin"],
    correct: "1",
    options: [
      { id: "1", label: "1 coin" },
      { id: "2", label: "2 coins" },
      { id: "3", label: "3 coins" },
      { id: "4", label: "4 coins" },
    ],
  },
  {
    id: "left-nail",
    difficulty: "easy",
    title: "The nail jar",
    text: "The nail jar holds 20 nails. You take 6. How many nails are left?",
    answer: "14.",
    accept: ["14", "fourteen"],
    correct: "14",
    options: [
      { id: "14", label: "14" },
      { id: "20", label: "20" },
      { id: "6", label: "6" },
    ],
  },
  {
    id: "left-biscuit",
    difficulty: "easy",
    title: "The biscuit tin",
    text: "The biscuit tin holds 12 biscuits. You take 5. How many biscuits are left?",
    answer: "7.",
    accept: ["7", "seven"],
    correct: "7",
    options: [
      { id: "7", label: "7" },
      { id: "12", label: "12" },
      { id: "5", label: "5" },
    ],
  },
  {
    id: "left-hook",
    difficulty: "easy",
    title: "The hook box",
    text: "The hook box holds 15 hooks. You take 4. How many hooks are left?",
    answer: "11.",
    accept: ["11", "eleven"],
    correct: "11",
    options: [
      { id: "11", label: "11" },
      { id: "15", label: "15" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "left-coal",
    difficulty: "easy",
    title: "The coal sack",
    text: "The coal sack holds 18 lumps. You take 7. How many lumps are left?",
    answer: "11.",
    accept: ["11", "eleven"],
    correct: "11",
    options: [
      { id: "11", label: "11" },
      { id: "18", label: "18" },
      { id: "7", label: "7" },
    ],
  },
  {
    id: "left-bottle",
    difficulty: "easy",
    title: "The bottle crate",
    text: "The bottle crate holds 24 bottles. You take 9. How many bottles are left?",
    answer: "15.",
    accept: ["15", "fifteen"],
    correct: "15",
    options: [
      { id: "15", label: "15" },
      { id: "24", label: "24" },
      { id: "9", label: "9" },
    ],
  },
  {
    id: "left-cup",
    difficulty: "easy",
    title: "The cup tray",
    text: "The cup tray holds 16 cups. You take 6. How many cups are left?",
    answer: "10.",
    accept: ["10", "ten"],
    correct: "10",
    options: [
      { id: "10", label: "10" },
      { id: "16", label: "16" },
      { id: "6", label: "6" },
    ],
  },
  {
    id: "left-line",
    difficulty: "easy",
    title: "The line coil",
    text: "The line coil holds 30 fathoms. You take 12. How many fathoms are left?",
    answer: "18.",
    accept: ["18", "eighteen"],
    correct: "18",
    options: [
      { id: "18", label: "18" },
      { id: "30", label: "30" },
      { id: "12", label: "12" },
    ],
  },
  {
    id: "left-cork",
    difficulty: "easy",
    title: "The cork bag",
    text: "The cork bag holds 40 corks. You take 15. How many corks are left?",
    answer: "25.",
    accept: ["25"],
    correct: "25",
    options: [
      { id: "25", label: "25" },
      { id: "40", label: "40" },
      { id: "15", label: "15" },
    ],
  },
  {
    id: "left-candle",
    difficulty: "easy",
    title: "The candle pot",
    text: "The candle pot holds 10 candles. You take 3. How many candles are left?",
    answer: "7.",
    accept: ["7", "seven"],
    correct: "7",
    options: [
      { id: "7", label: "7" },
      { id: "10", label: "10" },
      { id: "3", label: "3" },
    ],
  },
  {
    id: "left-key",
    difficulty: "easy",
    title: "The key drawer",
    text: "The key drawer holds 8 keys. You take 2. How many keys are left?",
    answer: "6.",
    accept: ["6", "six"],
    correct: "6",
    options: [
      { id: "6", label: "6" },
      { id: "8", label: "8" },
      { id: "2", label: "2" },
    ],
  },
  {
    id: "left-apple",
    difficulty: "easy",
    title: "The apple barrel",
    text: "The apple barrel holds 36 apples. You take 11. How many apples are left?",
    answer: "25.",
    accept: ["25"],
    correct: "25",
    options: [
      { id: "25", label: "25" },
      { id: "36", label: "36" },
      { id: "11", label: "11" },
    ],
  },
  {
    id: "left-oar",
    difficulty: "easy",
    title: "The oar rack",
    text: "The oar rack holds 9 oars. You take 4. How many oars are left?",
    answer: "5.",
    accept: ["5", "five"],
    correct: "5",
    options: [
      { id: "5", label: "5" },
      { id: "9", label: "9" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "left-lamp",
    difficulty: "easy",
    title: "The lamp shelf",
    text: "The lamp shelf holds 14 lamps. You take 5. How many lamps are left?",
    answer: "9.",
    accept: ["9", "nine"],
    correct: "9",
    options: [
      { id: "9", label: "9" },
      { id: "14", label: "14" },
      { id: "5", label: "5" },
    ],
  },
  {
    id: "left-bolt",
    difficulty: "easy",
    title: "The bolt bin",
    text: "The bolt bin holds 48 bolts. You take 18. How many bolts are left?",
    answer: "30.",
    accept: ["30", "thirty"],
    correct: "30",
    options: [
      { id: "30", label: "30" },
      { id: "48", label: "48" },
      { id: "18", label: "18" },
    ],
  },
  {
    id: "left-chart",
    difficulty: "easy",
    title: "The chart chest",
    text: "The chart chest holds 11 charts. You take 4. How many charts are left?",
    answer: "7.",
    accept: ["7", "seven"],
    correct: "7",
    options: [
      { id: "7", label: "7" },
      { id: "11", label: "11" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "left-fish",
    difficulty: "easy",
    title: "The fish basket",
    text: "The fish basket holds 22 fish. You take 8. How many fish are left?",
    answer: "14.",
    accept: ["14", "fourteen"],
    correct: "14",
    options: [
      { id: "14", label: "14" },
      { id: "22", label: "22" },
      { id: "8", label: "8" },
    ],
  },
  {
    id: "top-ropes",
    difficulty: "easy",
    title: "The stacked ropes",
    text: "The blue rope is under the white rope. The white rope is under the red rope. Which one is on top?",
    answer: "The red rope.",
    accept: ["the red rope", "red rope", "red"],
    correct: "red",
    options: [
      { id: "blue", label: "The blue rope" },
      { id: "white", label: "The white rope" },
      { id: "red", label: "The red rope" },
    ],
  },
  {
    id: "top-crates",
    difficulty: "easy",
    title: "The stacked crates",
    text: "The small crate is under the mid crate. The mid crate is under the large crate. Which one is on top?",
    answer: "The large crate.",
    accept: ["the large crate", "large crate", "large"],
    correct: "large",
    options: [
      { id: "small", label: "The small crate" },
      { id: "mid", label: "The mid crate" },
      { id: "large", label: "The large crate" },
    ],
  },
  {
    id: "top-charts",
    difficulty: "easy",
    title: "The stacked charts",
    text: "The old chart is under the fair chart. The fair chart is under the new chart. Which one is on top?",
    answer: "The new chart.",
    accept: ["the new chart", "new chart", "new"],
    correct: "new",
    options: [
      { id: "old", label: "The old chart" },
      { id: "fair", label: "The fair chart" },
      { id: "new", label: "The new chart" },
    ],
  },
  {
    id: "top-blankets",
    difficulty: "easy",
    title: "The stacked blankets",
    text: "The grey blanket is under the brown blanket. The brown blanket is under the red blanket. Which one is on top?",
    answer: "The red blanket.",
    accept: ["the red blanket", "red blanket", "red"],
    correct: "red",
    options: [
      { id: "grey", label: "The grey blanket" },
      { id: "brown", label: "The brown blanket" },
      { id: "red", label: "The red blanket" },
    ],
  },
  {
    id: "top-sacks",
    difficulty: "easy",
    title: "The stacked sacks",
    text: "The coal sack is under the flour sack. The flour sack is under the salt sack. Which one is on top?",
    answer: "The salt sack.",
    accept: ["the salt sack", "salt sack", "salt"],
    correct: "salt",
    options: [
      { id: "coal", label: "The coal sack" },
      { id: "flour", label: "The flour sack" },
      { id: "salt", label: "The salt sack" },
    ],
  },
  {
    id: "top-nets",
    difficulty: "easy",
    title: "The stacked nets",
    text: "The fine net is under the middling net. The middling net is under the coarse net. Which one is on top?",
    answer: "The coarse net.",
    accept: ["the coarse net", "coarse net", "coarse"],
    correct: "coarse",
    options: [
      { id: "fine", label: "The fine net" },
      { id: "middling", label: "The middling net" },
      { id: "coarse", label: "The coarse net" },
    ],
  },
  {
    id: "top-tins",
    difficulty: "easy",
    title: "The stacked tins",
    text: "The tea tin is under the sugar tin. The sugar tin is under the salt tin. Which one is on top?",
    answer: "The salt tin.",
    accept: ["the salt tin", "salt tin", "salt"],
    correct: "salt",
    options: [
      { id: "tea", label: "The tea tin" },
      { id: "sugar", label: "The sugar tin" },
      { id: "salt", label: "The salt tin" },
    ],
  },
  {
    id: "top-plates",
    difficulty: "easy",
    title: "The stacked plates",
    text: "The tin plate is under the wood plate. The wood plate is under the clay plate. Which one is on top?",
    answer: "The clay plate.",
    accept: ["the clay plate", "clay plate", "clay"],
    correct: "clay",
    options: [
      { id: "tin", label: "The tin plate" },
      { id: "wood", label: "The wood plate" },
      { id: "clay", label: "The clay plate" },
    ],
  },
  {
    id: "top-books",
    difficulty: "easy",
    title: "The stacked books",
    text: "The log book is under the tide book. The tide book is under the lamp book. Which one is on top?",
    answer: "The lamp book.",
    accept: ["the lamp book", "lamp book", "lamp"],
    correct: "lamp",
    options: [
      { id: "log", label: "The log book" },
      { id: "tide", label: "The tide book" },
      { id: "lamp", label: "The lamp book" },
    ],
  },
  {
    id: "top-coats",
    difficulty: "easy",
    title: "The stacked coats",
    text: "The oil coat is under the wool coat. The wool coat is under the canvas coat. Which one is on top?",
    answer: "The canvas coat.",
    accept: ["the canvas coat", "canvas coat", "canvas"],
    correct: "canvas",
    options: [
      { id: "oil", label: "The oil coat" },
      { id: "wool", label: "The wool coat" },
      { id: "canvas", label: "The canvas coat" },
    ],
  },
  {
    id: "top-boxes",
    difficulty: "easy",
    title: "The stacked boxes",
    text: "The nail box is under the hook box. The hook box is under the key box. Which one is on top?",
    answer: "The key box.",
    accept: ["the key box", "key box", "key"],
    correct: "key",
    options: [
      { id: "nail", label: "The nail box" },
      { id: "hook", label: "The hook box" },
      { id: "key", label: "The key box" },
    ],
  },
  {
    id: "top-lanterns",
    difficulty: "easy",
    title: "The stacked lanterns",
    text: "The small lantern is under the mid lantern. The mid lantern is under the tall lantern. Which one is on top?",
    answer: "The tall lantern.",
    accept: ["the tall lantern", "tall lantern", "tall"],
    correct: "tall",
    options: [
      { id: "small", label: "The small lantern" },
      { id: "mid", label: "The mid lantern" },
      { id: "tall", label: "The tall lantern" },
    ],
  },
  {
    id: "right-skiffs",
    difficulty: "easy",
    title: "The skiffs in a row",
    text: "The red skiff is left of the blue skiff. The blue skiff is left of the green skiff. Which is farthest right?",
    answer: "The green skiff.",
    accept: ["the green skiff", "green skiff", "green"],
    correct: "green",
    options: [
      { id: "red", label: "The red skiff" },
      { id: "blue", label: "The blue skiff" },
      { id: "green", label: "The green skiff" },
    ],
  },
  {
    id: "right-lamps",
    difficulty: "easy",
    title: "The lamps in a row",
    text: "The brass lamp is left of the iron lamp. The iron lamp is left of the tin lamp. Which is farthest right?",
    answer: "The tin lamp.",
    accept: ["the tin lamp", "tin lamp", "tin"],
    correct: "tin",
    options: [
      { id: "brass", label: "The brass lamp" },
      { id: "iron", label: "The iron lamp" },
      { id: "tin", label: "The tin lamp" },
    ],
  },
  {
    id: "right-barrels",
    difficulty: "easy",
    title: "The barrels in a row",
    text: "The tar barrel is left of the oil barrel. The oil barrel is left of the water barrel. Which is farthest right?",
    answer: "The water barrel.",
    accept: ["the water barrel", "water barrel", "water"],
    correct: "water",
    options: [
      { id: "tar", label: "The tar barrel" },
      { id: "oil", label: "The oil barrel" },
      { id: "water", label: "The water barrel" },
    ],
  },
  {
    id: "right-chairs",
    difficulty: "easy",
    title: "The chairs in a row",
    text: "The oak chair is left of the pine chair. The pine chair is left of the ash chair. Which is farthest right?",
    answer: "The ash chair.",
    accept: ["the ash chair", "ash chair", "ash"],
    correct: "ash",
    options: [
      { id: "oak", label: "The oak chair" },
      { id: "pine", label: "The pine chair" },
      { id: "ash", label: "The ash chair" },
    ],
  },
  {
    id: "right-boots",
    difficulty: "easy",
    title: "The boots in a row",
    text: "The left boot is left of the centre boot. The centre boot is left of the right boot. Which is farthest right?",
    answer: "The right boot.",
    accept: ["the right boot", "right boot", "right"],
    correct: "right",
    options: [
      { id: "left", label: "The left boot" },
      { id: "centre", label: "The centre boot" },
      { id: "right", label: "The right boot" },
    ],
  },
  {
    id: "right-pots",
    difficulty: "easy",
    title: "The pots in a row",
    text: "The clay pot is left of the iron pot. The iron pot is left of the copper pot. Which is farthest right?",
    answer: "The copper pot.",
    accept: ["the copper pot", "copper pot", "copper"],
    correct: "copper",
    options: [
      { id: "clay", label: "The clay pot" },
      { id: "iron", label: "The iron pot" },
      { id: "copper", label: "The copper pot" },
    ],
  },
  {
    id: "right-flags",
    difficulty: "easy",
    title: "The flags in a row",
    text: "The red flag is left of the white flag. The white flag is left of the blue flag. Which is farthest right?",
    answer: "The blue flag.",
    accept: ["the blue flag", "blue flag", "blue"],
    correct: "blue",
    options: [
      { id: "red", label: "The red flag" },
      { id: "white", label: "The white flag" },
      { id: "blue", label: "The blue flag" },
    ],
  },
  {
    id: "right-buoys",
    difficulty: "easy",
    title: "The buoys in a row",
    text: "The red buoy is left of the black buoy. The black buoy is left of the white buoy. Which is farthest right?",
    answer: "The white buoy.",
    accept: ["the white buoy", "white buoy", "white"],
    correct: "white",
    options: [
      { id: "red", label: "The red buoy" },
      { id: "black", label: "The black buoy" },
      { id: "white", label: "The white buoy" },
    ],
  },
  {
    id: "right-sheds",
    difficulty: "easy",
    title: "The sheds in a row",
    text: "The paint shed is left of the net shed. The net shed is left of the lamp shed. Which is farthest right?",
    answer: "The lamp shed.",
    accept: ["the lamp shed", "lamp shed", "lamp"],
    correct: "lamp",
    options: [
      { id: "paint", label: "The paint shed" },
      { id: "net", label: "The net shed" },
      { id: "lamp", label: "The lamp shed" },
    ],
  },
  {
    id: "right-gates",
    difficulty: "easy",
    title: "The gates in a row",
    text: "The yard gate is left of the field gate. The field gate is left of the shore gate. Which is farthest right?",
    answer: "The shore gate.",
    accept: ["the shore gate", "shore gate", "shore"],
    correct: "shore",
    options: [
      { id: "yard", label: "The yard gate" },
      { id: "field", label: "The field gate" },
      { id: "shore", label: "The shore gate" },
    ],
  },
  {
    id: "right-posts",
    difficulty: "easy",
    title: "The posts in a row",
    text: "The near post is left of the mid post. The mid post is left of the far post. Which is farthest right?",
    answer: "The far post.",
    accept: ["the far post", "far post", "far"],
    correct: "far",
    options: [
      { id: "near", label: "The near post" },
      { id: "mid", label: "The mid post" },
      { id: "far", label: "The far post" },
    ],
  },
  {
    id: "right-windows",
    difficulty: "easy",
    title: "The windows in a row",
    text: "The west window is left of the mid window. The mid window is left of the east window. Which is farthest right?",
    answer: "The east window.",
    accept: ["the east window", "east window", "east"],
    correct: "east",
    options: [
      { id: "west", label: "The west window" },
      { id: "mid", label: "The mid window" },
      { id: "east", label: "The east window" },
    ],
  },
  {
    id: "steps-1",
    difficulty: "easy",
    title: "Step 4 of 6",
    text: "6 steps lead up from the water. You stand on step 4, counting from the bottom. How many steps are above you?",
    answer: "2.",
    accept: ["2", "two"],
    correct: "2",
    options: [
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "4", label: "4" },
      { id: "6", label: "6" },
    ],
  },
  {
    id: "steps-2",
    difficulty: "easy",
    title: "Step 3 of 8",
    text: "8 steps lead up from the water. You stand on step 3, counting from the bottom. How many steps are above you?",
    answer: "5.",
    accept: ["5", "five"],
    correct: "5",
    options: [
      { id: "3", label: "3" },
      { id: "5", label: "5" },
      { id: "6", label: "6" },
      { id: "8", label: "8" },
    ],
  },
  {
    id: "steps-3",
    difficulty: "easy",
    title: "Step 5 of 9",
    text: "9 steps lead up from the water. You stand on step 5, counting from the bottom. How many steps are above you?",
    answer: "4.",
    accept: ["4", "four"],
    correct: "4",
    options: [
      { id: "4", label: "4" },
      { id: "5", label: "5" },
      { id: "9", label: "9" },
    ],
  },
  {
    id: "steps-4",
    difficulty: "easy",
    title: "Step 2 of 7",
    text: "7 steps lead up from the water. You stand on step 2, counting from the bottom. How many steps are above you?",
    answer: "5.",
    accept: ["5", "five"],
    correct: "5",
    options: [
      { id: "2", label: "2" },
      { id: "5", label: "5" },
      { id: "6", label: "6" },
      { id: "7", label: "7" },
    ],
  },
  {
    id: "steps-5",
    difficulty: "easy",
    title: "Step 6 of 10",
    text: "10 steps lead up from the water. You stand on step 6, counting from the bottom. How many steps are above you?",
    answer: "4.",
    accept: ["4", "four"],
    correct: "4",
    options: [
      { id: "4", label: "4" },
      { id: "5", label: "5" },
      { id: "6", label: "6" },
      { id: "10", label: "10" },
    ],
  },
  {
    id: "steps-6",
    difficulty: "easy",
    title: "Step 1 of 5",
    text: "5 steps lead up from the water. You stand on step 1, counting from the bottom. How many steps are above you?",
    answer: "4.",
    accept: ["4", "four"],
    correct: "4",
    options: [
      { id: "1", label: "1" },
      { id: "4", label: "4" },
      { id: "5", label: "5" },
    ],
  },
  {
    id: "steps-7",
    difficulty: "easy",
    title: "Step 7 of 12",
    text: "12 steps lead up from the water. You stand on step 7, counting from the bottom. How many steps are above you?",
    answer: "5.",
    accept: ["5", "five"],
    correct: "5",
    options: [
      { id: "5", label: "5" },
      { id: "6", label: "6" },
      { id: "7", label: "7" },
      { id: "12", label: "12" },
    ],
  },
  {
    id: "steps-8",
    difficulty: "easy",
    title: "Step 5 of 8",
    text: "8 steps lead up from the water. You stand on step 5, counting from the bottom. How many steps are above you?",
    answer: "3.",
    accept: ["3", "three"],
    correct: "3",
    options: [
      { id: "3", label: "3" },
      { id: "4", label: "4" },
      { id: "5", label: "5" },
      { id: "8", label: "8" },
    ],
  },
  {
    id: "steps-9",
    difficulty: "easy",
    title: "Step 4 of 11",
    text: "11 steps lead up from the water. You stand on step 4, counting from the bottom. How many steps are above you?",
    answer: "7.",
    accept: ["7", "seven"],
    correct: "7",
    options: [
      { id: "4", label: "4" },
      { id: "7", label: "7" },
      { id: "8", label: "8" },
      { id: "11", label: "11" },
    ],
  },
  {
    id: "steps-10",
    difficulty: "easy",
    title: "Step 2 of 9",
    text: "9 steps lead up from the water. You stand on step 2, counting from the bottom. How many steps are above you?",
    answer: "7.",
    accept: ["7", "seven"],
    correct: "7",
    options: [
      { id: "2", label: "2" },
      { id: "7", label: "7" },
      { id: "8", label: "8" },
      { id: "9", label: "9" },
    ],
  },
  {
    id: "steps-11",
    difficulty: "easy",
    title: "Step 6 of 7",
    text: "7 steps lead up from the water. You stand on step 6, counting from the bottom. How many steps are above you?",
    answer: "1.",
    accept: ["1", "one"],
    correct: "1",
    options: [
      { id: "1", label: "1" },
      { id: "2", label: "2" },
      { id: "6", label: "6" },
      { id: "7", label: "7" },
    ],
  },
  {
    id: "steps-12",
    difficulty: "easy",
    title: "Step 3 of 10",
    text: "10 steps lead up from the water. You stand on step 3, counting from the bottom. How many steps are above you?",
    answer: "7.",
    accept: ["7", "seven"],
    correct: "7",
    options: [
      { id: "3", label: "3" },
      { id: "7", label: "7" },
      { id: "8", label: "8" },
      { id: "10", label: "10" },
    ],
  },
  {
    id: "half-tea",
    difficulty: "easy",
    title: "The tea cup",
    text: "The tea cup holds 8 cups of tea. You use half. How many cups are left?",
    answer: "4.",
    accept: ["4", "four"],
    correct: "4",
    options: [
      { id: "4", label: "4" },
      { id: "8", label: "8" },
      { id: "2", label: "2" },
      { id: "7", label: "7" },
    ],
  },
  {
    id: "half-water",
    difficulty: "easy",
    title: "The water jug",
    text: "The water jug holds 6 cups of water. You use half. How many cups are left?",
    answer: "3.",
    accept: ["3", "three"],
    correct: "3",
    options: [
      { id: "3", label: "3" },
      { id: "6", label: "6" },
      { id: "1", label: "1" },
      { id: "5", label: "5" },
    ],
  },
  {
    id: "half-oil",
    difficulty: "easy",
    title: "The oil can",
    text: "The oil can holds 10 cups of oil. You use half. How many cups are left?",
    answer: "5.",
    accept: ["5", "five"],
    correct: "5",
    options: [
      { id: "5", label: "5" },
      { id: "10", label: "10" },
      { id: "2", label: "2" },
      { id: "9", label: "9" },
    ],
  },
  {
    id: "half-milk",
    difficulty: "easy",
    title: "The milk pail",
    text: "The milk pail holds 4 cups of milk. You use half. How many cups are left?",
    answer: "2.",
    accept: ["2", "two"],
    correct: "2",
    options: [
      { id: "2", label: "2" },
      { id: "4", label: "4" },
      { id: "1", label: "1" },
      { id: "3", label: "3" },
    ],
  },
  {
    id: "half-soup",
    difficulty: "easy",
    title: "The soup bowl",
    text: "The soup bowl holds 12 cups of soup. You use half. How many cups are left?",
    answer: "6.",
    accept: ["6", "six"],
    correct: "6",
    options: [
      { id: "6", label: "6" },
      { id: "12", label: "12" },
      { id: "3", label: "3" },
      { id: "11", label: "11" },
    ],
  },
  {
    id: "half-ink",
    difficulty: "easy",
    title: "The ink pot",
    text: "The ink pot holds 2 cups of ink. You use half. How many cups are left?",
    answer: "1.",
    accept: ["1", "one"],
    correct: "1",
    options: [
      { id: "1", label: "1" },
      { id: "2", label: "2" },
    ],
  },
  {
    id: "half-paint",
    difficulty: "easy",
    title: "The paint tin",
    text: "The paint tin holds 16 cups of paint. You use half. How many cups are left?",
    answer: "8.",
    accept: ["8", "eight"],
    correct: "8",
    options: [
      { id: "8", label: "8" },
      { id: "16", label: "16" },
      { id: "4", label: "4" },
      { id: "15", label: "15" },
    ],
  },
  {
    id: "half-broth",
    difficulty: "easy",
    title: "The broth pot",
    text: "The broth pot holds 14 cups of broth. You use half. How many cups are left?",
    answer: "7.",
    accept: ["7", "seven"],
    correct: "7",
    options: [
      { id: "7", label: "7" },
      { id: "14", label: "14" },
      { id: "3", label: "3" },
      { id: "13", label: "13" },
    ],
  },
  {
    id: "side-mast",
    difficulty: "easy",
    title: "The short mast",
    text: "The tall mast is on the left. Which side is the short mast on?",
    answer: "The right.",
    accept: ["the right", "right"],
    correct: "right",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "side-ladder",
    difficulty: "easy",
    title: "The short ladder",
    text: "The long ladder is on the right. Which side is the short ladder on?",
    answer: "The left.",
    accept: ["the left", "left"],
    correct: "left",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "side-bench",
    difficulty: "easy",
    title: "The narrow bench",
    text: "The wide bench is on the left. Which side is the narrow bench on?",
    answer: "The right.",
    accept: ["the right", "right"],
    correct: "right",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "side-shelf",
    difficulty: "easy",
    title: "The low shelf",
    text: "The high shelf is on the right. Which side is the low shelf on?",
    answer: "The left.",
    accept: ["the left", "left"],
    correct: "left",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "side-door",
    difficulty: "easy",
    title: "The back door",
    text: "The front door is on the left. Which side is the back door on?",
    answer: "The right.",
    accept: ["the right", "right"],
    correct: "right",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "side-path",
    difficulty: "easy",
    title: "The dirt path",
    text: "The paved path is on the right. Which side is the dirt path on?",
    answer: "The left.",
    accept: ["the left", "left"],
    correct: "left",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "side-hook",
    difficulty: "easy",
    title: "The iron hook",
    text: "The brass hook is on the left. Which side is the iron hook on?",
    answer: "The right.",
    accept: ["the right", "right"],
    correct: "right",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "side-bell",
    difficulty: "easy",
    title: "The small bell",
    text: "The big bell is on the right. Which side is the small bell on?",
    answer: "The left.",
    accept: ["the left", "left"],
    correct: "left",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "side-sail",
    difficulty: "easy",
    title: "The jib sail",
    text: "The main sail is on the left. Which side is the jib sail on?",
    answer: "The right.",
    accept: ["the right", "right"],
    correct: "right",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "side-anchor",
    difficulty: "easy",
    title: "The light anchor",
    text: "The heavy anchor is on the right. Which side is the light anchor on?",
    answer: "The left.",
    accept: ["the left", "left"],
    correct: "left",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "side-chest",
    difficulty: "easy",
    title: "The open chest",
    text: "The locked chest is on the left. Which side is the open chest on?",
    answer: "The right.",
    accept: ["the right", "right"],
    correct: "right",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "side-stove",
    difficulty: "easy",
    title: "The cold stove",
    text: "The hot stove is on the right. Which side is the cold stove on?",
    answer: "The left.",
    accept: ["the left", "left"],
    correct: "left",
    options: [
      { id: "left", label: "The left" },
      { id: "right", label: "The right" },
    ],
  },
  {
    id: "grid-net-1",
    difficulty: "medium",
    title: "The net count",
    text: "The net has 4 rows, and each row has 5 corks. How many corks is that?",
    answer: "20.",
    accept: ["20", "twenty"],
    correct: "20",
    options: [
      { id: "20", label: "20" },
      { id: "9", label: "9" },
      { id: "16", label: "16" },
      { id: "5", label: "5" },
    ],
  },
  {
    id: "grid-crate-2",
    difficulty: "medium",
    title: "The crate count",
    text: "The crate has 3 rows, and each row has 8 bottles. How many bottles is that?",
    answer: "24.",
    accept: ["24", "twenty-four"],
    correct: "24",
    options: [
      { id: "24", label: "24" },
      { id: "11", label: "11" },
      { id: "21", label: "21" },
      { id: "8", label: "8" },
    ],
  },
  {
    id: "grid-tray-3",
    difficulty: "medium",
    title: "The tray count",
    text: "The tray has 2 rows, and each row has 9 cups. How many cups is that?",
    answer: "18.",
    accept: ["18", "eighteen"],
    correct: "18",
    options: [
      { id: "18", label: "18" },
      { id: "11", label: "11" },
      { id: "16", label: "16" },
      { id: "9", label: "9" },
    ],
  },
  {
    id: "grid-chart-4",
    difficulty: "medium",
    title: "The chart count",
    text: "The chart has 6 rows, and each row has 6 squares. How many squares is that?",
    answer: "36.",
    accept: ["36", "thirty-six"],
    correct: "36",
    options: [
      { id: "36", label: "36" },
      { id: "12", label: "12" },
      { id: "30", label: "30" },
      { id: "6", label: "6" },
    ],
  },
  {
    id: "grid-window-5",
    difficulty: "medium",
    title: "The window count",
    text: "The window has 3 rows, and each row has 4 panes. How many panes is that?",
    answer: "12.",
    accept: ["12", "twelve"],
    correct: "12",
    options: [
      { id: "12", label: "12" },
      { id: "7", label: "7" },
      { id: "9", label: "9" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "grid-fence-6",
    difficulty: "medium",
    title: "The fence count",
    text: "The fence has 5 rows, and each row has 5 posts. How many posts is that?",
    answer: "25.",
    accept: ["25"],
    correct: "25",
    options: [
      { id: "25", label: "25" },
      { id: "10", label: "10" },
      { id: "20", label: "20" },
      { id: "5", label: "5" },
    ],
  },
  {
    id: "grid-shelf-7",
    difficulty: "medium",
    title: "The shelf count",
    text: "The shelf has 4 rows, and each row has 6 jars. How many jars is that?",
    answer: "24.",
    accept: ["24", "twenty-four"],
    correct: "24",
    options: [
      { id: "24", label: "24" },
      { id: "10", label: "10" },
      { id: "20", label: "20" },
      { id: "6", label: "6" },
    ],
  },
  {
    id: "grid-wall-8",
    difficulty: "medium",
    title: "The wall count",
    text: "The wall has 7 rows, and each row has 3 hooks. How many hooks is that?",
    answer: "21.",
    accept: ["21"],
    correct: "21",
    options: [
      { id: "21", label: "21" },
      { id: "10", label: "10" },
      { id: "14", label: "14" },
      { id: "3", label: "3" },
    ],
  },
  {
    id: "grid-sail-9",
    difficulty: "medium",
    title: "The sail count",
    text: "The sail has 8 rows, and each row has 2 patches. How many patches is that?",
    answer: "16.",
    accept: ["16", "sixteen"],
    correct: "16",
    options: [
      { id: "16", label: "16" },
      { id: "10", label: "10" },
      { id: "8", label: "8" },
      { id: "2", label: "2" },
    ],
  },
  {
    id: "grid-floor-10",
    difficulty: "medium",
    title: "The floor count",
    text: "The floor has 9 rows, and each row has 4 boards. How many boards is that?",
    answer: "36.",
    accept: ["36", "thirty-six"],
    correct: "36",
    options: [
      { id: "36", label: "36" },
      { id: "13", label: "13" },
      { id: "27", label: "27" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "grid-roof-11",
    difficulty: "medium",
    title: "The roof count",
    text: "The roof has 6 rows, and each row has 5 slates. How many slates is that?",
    answer: "30.",
    accept: ["30", "thirty"],
    correct: "30",
    options: [
      { id: "30", label: "30" },
      { id: "11", label: "11" },
      { id: "24", label: "24" },
      { id: "5", label: "5" },
    ],
  },
  {
    id: "grid-ladder-12",
    difficulty: "medium",
    title: "The ladder count",
    text: "The ladder has 2 rows, and each row has 12 rungs. How many rungs is that?",
    answer: "24.",
    accept: ["24", "twenty-four"],
    correct: "24",
    options: [
      { id: "24", label: "24" },
      { id: "14", label: "14" },
      { id: "22", label: "22" },
      { id: "12", label: "12" },
    ],
  },
  {
    id: "grid-book-13",
    difficulty: "medium",
    title: "The book count",
    text: "The book has 5 rows, and each row has 8 rows. How many rows is that?",
    answer: "40.",
    accept: ["40", "forty"],
    correct: "40",
    options: [
      { id: "40", label: "40" },
      { id: "13", label: "13" },
      { id: "35", label: "35" },
      { id: "8", label: "8" },
    ],
  },
  {
    id: "grid-box-14",
    difficulty: "medium",
    title: "The box count",
    text: "The box has 10 rows, and each row has 4 nails. How many nails is that?",
    answer: "40.",
    accept: ["40", "forty"],
    correct: "40",
    options: [
      { id: "40", label: "40" },
      { id: "14", label: "14" },
      { id: "30", label: "30" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "grid-rack-15",
    difficulty: "medium",
    title: "The rack count",
    text: "The rack has 3 rows, and each row has 6 coats. How many coats is that?",
    answer: "18.",
    accept: ["18", "eighteen"],
    correct: "18",
    options: [
      { id: "18", label: "18" },
      { id: "9", label: "9" },
      { id: "15", label: "15" },
      { id: "6", label: "6" },
    ],
  },
  {
    id: "grid-pier-16",
    difficulty: "medium",
    title: "The pier count",
    text: "The pier has 4 rows, and each row has 8 rings. How many rings is that?",
    answer: "32.",
    accept: ["32"],
    correct: "32",
    options: [
      { id: "32", label: "32" },
      { id: "12", label: "12" },
      { id: "28", label: "28" },
      { id: "8", label: "8" },
    ],
  },
  {
    id: "cuts-rope",
    difficulty: "medium",
    title: "Cutting the rope",
    text: "A rope is cut into 3 equal pieces. How many cuts does that take?",
    answer: "2.",
    accept: ["2", "two"],
    correct: "2",
    options: [
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "1", label: "1" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "cuts-line",
    difficulty: "medium",
    title: "Cutting the line",
    text: "A line is cut into 4 equal pieces. How many cuts does that take?",
    answer: "3.",
    accept: ["3", "three"],
    correct: "3",
    options: [
      { id: "3", label: "3" },
      { id: "4", label: "4" },
      { id: "2", label: "2" },
      { id: "5", label: "5" },
    ],
  },
  {
    id: "cuts-chain",
    difficulty: "medium",
    title: "Cutting the chain",
    text: "A chain is cut into 5 equal pieces. How many cuts does that take?",
    answer: "4.",
    accept: ["4", "four"],
    correct: "4",
    options: [
      { id: "4", label: "4" },
      { id: "5", label: "5" },
      { id: "3", label: "3" },
      { id: "6", label: "6" },
    ],
  },
  {
    id: "cuts-wire",
    difficulty: "medium",
    title: "Cutting the wire",
    text: "A wire is cut into 6 equal pieces. How many cuts does that take?",
    answer: "5.",
    accept: ["5", "five"],
    correct: "5",
    options: [
      { id: "5", label: "5" },
      { id: "6", label: "6" },
      { id: "4", label: "4" },
      { id: "7", label: "7" },
    ],
  },
  {
    id: "cuts-twine",
    difficulty: "medium",
    title: "Cutting the twine",
    text: "A twine is cut into 7 equal pieces. How many cuts does that take?",
    answer: "6.",
    accept: ["6", "six"],
    correct: "6",
    options: [
      { id: "6", label: "6" },
      { id: "7", label: "7" },
      { id: "5", label: "5" },
      { id: "8", label: "8" },
    ],
  },
  {
    id: "cuts-cable",
    difficulty: "medium",
    title: "Cutting the cable",
    text: "A cable is cut into 8 equal pieces. How many cuts does that take?",
    answer: "7.",
    accept: ["7", "seven"],
    correct: "7",
    options: [
      { id: "7", label: "7" },
      { id: "8", label: "8" },
      { id: "6", label: "6" },
      { id: "9", label: "9" },
    ],
  },
  {
    id: "cuts-cord",
    difficulty: "medium",
    title: "Cutting the cord",
    text: "A cord is cut into 9 equal pieces. How many cuts does that take?",
    answer: "8.",
    accept: ["8", "eight"],
    correct: "8",
    options: [
      { id: "8", label: "8" },
      { id: "9", label: "9" },
      { id: "7", label: "7" },
      { id: "10", label: "10" },
    ],
  },
  {
    id: "cuts-yarn",
    difficulty: "medium",
    title: "Cutting the yarn",
    text: "A yarn is cut into 10 equal pieces. How many cuts does that take?",
    answer: "9.",
    accept: ["9", "nine"],
    correct: "9",
    options: [
      { id: "9", label: "9" },
      { id: "10", label: "10" },
      { id: "8", label: "8" },
      { id: "11", label: "11" },
    ],
  },
  {
    id: "cuts-tape",
    difficulty: "medium",
    title: "Cutting the tape",
    text: "A tape is cut into 12 equal pieces. How many cuts does that take?",
    answer: "11.",
    accept: ["11", "eleven"],
    correct: "11",
    options: [
      { id: "11", label: "11" },
      { id: "12", label: "12" },
      { id: "10", label: "10" },
      { id: "13", label: "13" },
    ],
  },
  {
    id: "cuts-lead",
    difficulty: "medium",
    title: "Cutting the lead",
    text: "A lead is cut into 15 equal pieces. How many cuts does that take?",
    answer: "14.",
    accept: ["14", "fourteen"],
    correct: "14",
    options: [
      { id: "14", label: "14" },
      { id: "15", label: "15" },
      { id: "13", label: "13" },
      { id: "16", label: "16" },
    ],
  },
  {
    id: "cuts-hose",
    difficulty: "medium",
    title: "Cutting the hose",
    text: "A hose is cut into 16 equal pieces. How many cuts does that take?",
    answer: "15.",
    accept: ["15", "fifteen"],
    correct: "15",
    options: [
      { id: "15", label: "15" },
      { id: "16", label: "16" },
      { id: "14", label: "14" },
      { id: "17", label: "17" },
    ],
  },
  {
    id: "cuts-wick",
    difficulty: "medium",
    title: "Cutting the wick",
    text: "A wick is cut into 20 equal pieces. How many cuts does that take?",
    answer: "19.",
    accept: ["19"],
    correct: "19",
    options: [
      { id: "19", label: "19" },
      { id: "20", label: "20" },
      { id: "18", label: "18" },
      { id: "21", label: "21" },
    ],
  },
  {
    id: "ferry-1",
    difficulty: "medium",
    title: "Ferry 1",
    text: "A ferry leaves every 20 minutes, starting at 9. You arrive at quarter to ten. When is the next ferry?",
    answer: "10:00.",
    accept: ["10:00", "1000", "10:00"],
    correct: "t1000",
    options: [
      { id: "missed", label: "9:40" },
      { id: "t1000", label: "10:00" },
      { id: "later", label: "10:20" },
      { id: "early", label: "9:00" },
    ],
  },
  {
    id: "ferry-2",
    difficulty: "medium",
    title: "Ferry 2",
    text: "A ferry leaves every 15 minutes, starting at 8. You arrive at twenty past eight. When is the next ferry?",
    answer: "8:30.",
    accept: ["8:30", "830", "8:30"],
    correct: "t830",
    options: [
      { id: "missed", label: "8:15" },
      { id: "t830", label: "8:30" },
      { id: "later", label: "8:45" },
      { id: "early", label: "8:00" },
    ],
  },
  {
    id: "ferry-3",
    difficulty: "medium",
    title: "Ferry 3",
    text: "A ferry leaves every 30 minutes, starting at 10. You arrive at half past ten. When is the next ferry?",
    answer: "11:00.",
    accept: ["11:00", "1100", "11:00"],
    correct: "t1100",
    options: [
      { id: "missed", label: "10:30" },
      { id: "t1100", label: "11:00" },
      { id: "later", label: "11:30" },
      { id: "early", label: "10:00" },
    ],
  },
  {
    id: "ferry-4",
    difficulty: "medium",
    title: "Ferry 4",
    text: "A ferry leaves every 20 minutes, starting at 7. You arrive at ten to eight. When is the next ferry?",
    answer: "8:00.",
    accept: ["8:00", "800", "8:00"],
    correct: "t800",
    options: [
      { id: "missed", label: "7:40" },
      { id: "t800", label: "8:00" },
      { id: "later", label: "8:20" },
      { id: "early", label: "7:00" },
    ],
  },
  {
    id: "ferry-5",
    difficulty: "medium",
    title: "Ferry 5",
    text: "A ferry leaves every 15 minutes, starting at 11. You arrive at twenty to twelve. When is the next ferry?",
    answer: "11:45.",
    accept: ["11:45", "1145", "11:45"],
    correct: "t1145",
    options: [
      { id: "missed", label: "11:30" },
      { id: "t1145", label: "11:45" },
      { id: "later", label: "12:00" },
      { id: "early", label: "11:00" },
    ],
  },
  {
    id: "ferry-6",
    difficulty: "medium",
    title: "Ferry 6",
    text: "A ferry leaves every 30 minutes, starting at 1. You arrive at a quarter past one. When is the next ferry?",
    answer: "1:30.",
    accept: ["1:30", "130", "1:30"],
    correct: "t130",
    options: [
      { id: "missed", label: "1:00" },
      { id: "t130", label: "1:30" },
      { id: "later", label: "2:00" },
      { id: "early", label: "1:00" },
    ],
  },
  {
    id: "ferry-7",
    difficulty: "medium",
    title: "Ferry 7",
    text: "A ferry leaves every 10 minutes, starting at 6. You arrive at twenty-five past six. When is the next ferry?",
    answer: "6:30.",
    accept: ["6:30", "630", "6:30"],
    correct: "t630",
    options: [
      { id: "missed", label: "6:20" },
      { id: "t630", label: "6:30" },
      { id: "later", label: "6:40" },
      { id: "early", label: "6:00" },
    ],
  },
  {
    id: "ferry-8",
    difficulty: "medium",
    title: "Ferry 8",
    text: "A ferry leaves every 20 minutes, starting at 4. You arrive at ten past four. When is the next ferry?",
    answer: "4:20.",
    accept: ["4:20", "420", "4:20"],
    correct: "t420",
    options: [
      { id: "missed", label: "4:00" },
      { id: "t420", label: "4:20" },
      { id: "later", label: "4:40" },
      { id: "early", label: "4:00" },
    ],
  },
  {
    id: "ferry-9",
    difficulty: "medium",
    title: "Ferry 9",
    text: "A ferry leaves every 15 minutes, starting at 2. You arrive at ten to three. When is the next ferry?",
    answer: "3:00.",
    accept: ["3:00", "300", "3:00"],
    correct: "t300",
    options: [
      { id: "missed", label: "2:45" },
      { id: "t300", label: "3:00" },
      { id: "later", label: "3:15" },
      { id: "early", label: "2:00" },
    ],
  },
  {
    id: "ferry-10",
    difficulty: "medium",
    title: "Ferry 10",
    text: "A ferry leaves every 30 minutes, starting at 3. You arrive at a quarter to four. When is the next ferry?",
    answer: "4:00.",
    accept: ["4:00", "400", "4:00"],
    correct: "t400",
    options: [
      { id: "missed", label: "3:30" },
      { id: "t400", label: "4:00" },
      { id: "later", label: "4:30" },
      { id: "early", label: "3:00" },
    ],
  },
  {
    id: "ferry-11",
    difficulty: "medium",
    title: "Ferry 11",
    text: "A ferry leaves every 10 minutes, starting at 5. You arrive at twenty-five to six. When is the next ferry?",
    answer: "5:40.",
    accept: ["5:40", "540", "5:40"],
    correct: "t540",
    options: [
      { id: "missed", label: "5:30" },
      { id: "t540", label: "5:40" },
      { id: "later", label: "5:50" },
      { id: "early", label: "5:00" },
    ],
  },
  {
    id: "ferry-12",
    difficulty: "medium",
    title: "Ferry 12",
    text: "A ferry leaves every 20 minutes, starting at 12. You arrive at half past twelve. When is the next ferry?",
    answer: "12:40.",
    accept: ["12:40", "1240", "12:40"],
    correct: "t1240",
    options: [
      { id: "missed", label: "12:20" },
      { id: "t1240", label: "12:40" },
      { id: "later", label: "13:00" },
      { id: "early", label: "12:00" },
    ],
  },
  {
    id: "walk-1",
    difficulty: "medium",
    title: "Passage 1",
    text: "The passage is 12 paces long. You walk 6 paces in, then 2 paces back, then 4 paces in again. How many paces are you from the start?",
    answer: "8.",
    accept: ["8", "eight"],
    correct: "8",
    options: [
      { id: "8", label: "8" },
      { id: "10", label: "10" },
      { id: "12", label: "12" },
    ],
  },
  {
    id: "walk-2",
    difficulty: "medium",
    title: "Passage 2",
    text: "The passage is 20 paces long. You walk 8 paces in, then 3 paces back, then 6 paces in again. How many paces are you from the start?",
    answer: "11.",
    accept: ["11", "eleven"],
    correct: "11",
    options: [
      { id: "11", label: "11" },
      { id: "14", label: "14" },
      { id: "20", label: "20" },
    ],
  },
  {
    id: "walk-3",
    difficulty: "medium",
    title: "Passage 3",
    text: "The passage is 15 paces long. You walk 9 paces in, then 4 paces back, then 3 paces in again. How many paces are you from the start?",
    answer: "8.",
    accept: ["8", "eight"],
    correct: "8",
    options: [
      { id: "8", label: "8" },
      { id: "12", label: "12" },
      { id: "15", label: "15" },
    ],
  },
  {
    id: "walk-4",
    difficulty: "medium",
    title: "Passage 4",
    text: "The passage is 18 paces long. You walk 7 paces in, then 2 paces back, then 8 paces in again. How many paces are you from the start?",
    answer: "13.",
    accept: ["13", "thirteen"],
    correct: "13",
    options: [
      { id: "13", label: "13" },
      { id: "15", label: "15" },
      { id: "18", label: "18" },
    ],
  },
  {
    id: "walk-5",
    difficulty: "medium",
    title: "Passage 5",
    text: "The passage is 10 paces long. You walk 4 paces in, then 1 paces back, then 4 paces in again. How many paces are you from the start?",
    answer: "7.",
    accept: ["7", "seven"],
    correct: "7",
    options: [
      { id: "7", label: "7" },
      { id: "8", label: "8" },
      { id: "10", label: "10" },
    ],
  },
  {
    id: "walk-6",
    difficulty: "medium",
    title: "Passage 6",
    text: "The passage is 16 paces long. You walk 6 paces in, then 5 paces back, then 7 paces in again. How many paces are you from the start?",
    answer: "8.",
    accept: ["8", "eight"],
    correct: "8",
    options: [
      { id: "8", label: "8" },
      { id: "13", label: "13" },
      { id: "16", label: "16" },
    ],
  },
  {
    id: "walk-7",
    difficulty: "medium",
    title: "Passage 7",
    text: "The passage is 14 paces long. You walk 8 paces in, then 3 paces back, then 2 paces in again. How many paces are you from the start?",
    answer: "7.",
    accept: ["7", "seven"],
    correct: "7",
    options: [
      { id: "7", label: "7" },
      { id: "10", label: "10" },
      { id: "14", label: "14" },
    ],
  },
  {
    id: "walk-8",
    difficulty: "medium",
    title: "Passage 8",
    text: "The passage is 22 paces long. You walk 10 paces in, then 4 paces back, then 5 paces in again. How many paces are you from the start?",
    answer: "11.",
    accept: ["11", "eleven"],
    correct: "11",
    options: [
      { id: "11", label: "11" },
      { id: "15", label: "15" },
      { id: "22", label: "22" },
    ],
  },
  {
    id: "walk-9",
    difficulty: "medium",
    title: "Passage 9",
    text: "The passage is 9 paces long. You walk 3 paces in, then 1 paces back, then 4 paces in again. How many paces are you from the start?",
    answer: "6.",
    accept: ["6", "six"],
    correct: "6",
    options: [
      { id: "6", label: "6" },
      { id: "7", label: "7" },
      { id: "9", label: "9" },
    ],
  },
  {
    id: "walk-10",
    difficulty: "medium",
    title: "Passage 10",
    text: "The passage is 24 paces long. You walk 9 paces in, then 6 paces back, then 8 paces in again. How many paces are you from the start?",
    answer: "11.",
    accept: ["11", "eleven"],
    correct: "11",
    options: [
      { id: "11", label: "11" },
      { id: "17", label: "17" },
      { id: "24", label: "24" },
    ],
  },
  {
    id: "walk-11",
    difficulty: "medium",
    title: "Passage 11",
    text: "The passage is 11 paces long. You walk 5 paces in, then 2 paces back, then 6 paces in again. How many paces are you from the start?",
    answer: "9.",
    accept: ["9", "nine"],
    correct: "9",
    options: [
      { id: "9", label: "9" },
      { id: "11", label: "11" },
    ],
  },
  {
    id: "walk-12",
    difficulty: "medium",
    title: "Passage 12",
    text: "The passage is 13 paces long. You walk 7 paces in, then 3 paces back, then 4 paces in again. How many paces are you from the start?",
    answer: "8.",
    accept: ["8", "eight"],
    correct: "8",
    options: [
      { id: "8", label: "8" },
      { id: "11", label: "11" },
      { id: "13", label: "13" },
    ],
  },
  {
    id: "seq-2",
    difficulty: "medium",
    title: "The list from 2",
    text: "The list reads 2, then at 3, then at 5, then at 8. Each gap is one larger than the gap before it. What number comes next?",
    answer: "12.",
    accept: ["12", "twelve"],
    correct: "12",
    options: [
      { id: "12", label: "12" },
      { id: "11", label: "11" },
      { id: "13", label: "13" },
      { id: "9", label: "9" },
    ],
  },
  {
    id: "seq-5",
    difficulty: "medium",
    title: "The list from 5",
    text: "The list reads 5, then at 6, then at 8, then at 11. Each gap is one larger than the gap before it. What number comes next?",
    answer: "15.",
    accept: ["15", "fifteen"],
    correct: "15",
    options: [
      { id: "15", label: "15" },
      { id: "14", label: "14" },
      { id: "16", label: "16" },
      { id: "12", label: "12" },
    ],
  },
  {
    id: "seq-6",
    difficulty: "medium",
    title: "The list from 6",
    text: "The list reads 6, then at 7, then at 9, then at 12. Each gap is one larger than the gap before it. What number comes next?",
    answer: "16.",
    accept: ["16", "sixteen"],
    correct: "16",
    options: [
      { id: "16", label: "16" },
      { id: "15", label: "15" },
      { id: "17", label: "17" },
      { id: "13", label: "13" },
    ],
  },
  {
    id: "seq-7",
    difficulty: "medium",
    title: "The list from 7",
    text: "The list reads 7, then at 8, then at 10, then at 13. Each gap is one larger than the gap before it. What number comes next?",
    answer: "17.",
    accept: ["17"],
    correct: "17",
    options: [
      { id: "17", label: "17" },
      { id: "16", label: "16" },
      { id: "18", label: "18" },
      { id: "14", label: "14" },
    ],
  },
  {
    id: "seq-8",
    difficulty: "medium",
    title: "The list from 8",
    text: "The list reads 8, then at 9, then at 11, then at 14. Each gap is one larger than the gap before it. What number comes next?",
    answer: "18.",
    accept: ["18", "eighteen"],
    correct: "18",
    options: [
      { id: "18", label: "18" },
      { id: "17", label: "17" },
      { id: "19", label: "19" },
      { id: "15", label: "15" },
    ],
  },
  {
    id: "seq-10",
    difficulty: "medium",
    title: "The list from 10",
    text: "The list reads 10, then at 11, then at 13, then at 16. Each gap is one larger than the gap before it. What number comes next?",
    answer: "20.",
    accept: ["20", "twenty"],
    correct: "20",
    options: [
      { id: "20", label: "20" },
      { id: "19", label: "19" },
      { id: "21", label: "21" },
      { id: "17", label: "17" },
    ],
  },
  {
    id: "seq-11",
    difficulty: "medium",
    title: "The list from 11",
    text: "The list reads 11, then at 12, then at 14, then at 17. Each gap is one larger than the gap before it. What number comes next?",
    answer: "21.",
    accept: ["21"],
    correct: "21",
    options: [
      { id: "21", label: "21" },
      { id: "20", label: "20" },
      { id: "22", label: "22" },
      { id: "18", label: "18" },
    ],
  },
  {
    id: "seq-12",
    difficulty: "medium",
    title: "The list from 12",
    text: "The list reads 12, then at 13, then at 15, then at 18. Each gap is one larger than the gap before it. What number comes next?",
    answer: "22.",
    accept: ["22"],
    correct: "22",
    options: [
      { id: "22", label: "22" },
      { id: "21", label: "21" },
      { id: "23", label: "23" },
      { id: "19", label: "19" },
    ],
  },
  {
    id: "seq-14",
    difficulty: "medium",
    title: "The list from 14",
    text: "The list reads 14, then at 15, then at 17, then at 20. Each gap is one larger than the gap before it. What number comes next?",
    answer: "24.",
    accept: ["24", "twenty-four"],
    correct: "24",
    options: [
      { id: "24", label: "24" },
      { id: "23", label: "23" },
      { id: "25", label: "25" },
      { id: "21", label: "21" },
    ],
  },
  {
    id: "seq-15",
    difficulty: "medium",
    title: "The list from 15",
    text: "The list reads 15, then at 16, then at 18, then at 21. Each gap is one larger than the gap before it. What number comes next?",
    answer: "25.",
    accept: ["25"],
    correct: "25",
    options: [
      { id: "25", label: "25" },
      { id: "24", label: "24" },
      { id: "26", label: "26" },
      { id: "22", label: "22" },
    ],
  },
  {
    id: "slow-1",
    difficulty: "medium",
    title: "Losing 10 minutes over 3 hours",
    text: "A clock loses 10 minutes every true hour. It is set right at noon. What time does it show after 3 true hours?",
    answer: "2:30.",
    accept: ["2:30", "230"],
    correct: "c230",
    options: [
      { id: "true", label: "3:00" },
      { id: "c230", label: "2:30" },
      { id: "early", label: "1:00" },
      { id: "late", label: "3:00" },
    ],
  },
  {
    id: "slow-2",
    difficulty: "medium",
    title: "Losing 10 minutes over 4 hours",
    text: "A clock loses 10 minutes every true hour. It is set right at noon. What time does it show after 4 true hours?",
    answer: "3:20.",
    accept: ["3:20", "320"],
    correct: "c320",
    options: [
      { id: "true", label: "4:00" },
      { id: "c320", label: "3:20" },
      { id: "early", label: "2:00" },
      { id: "late", label: "4:00" },
    ],
  },
  {
    id: "slow-3",
    difficulty: "medium",
    title: "Losing 10 minutes over 5 hours",
    text: "A clock loses 10 minutes every true hour. It is set right at noon. What time does it show after 5 true hours?",
    answer: "4:10.",
    accept: ["4:10", "410"],
    correct: "c410",
    options: [
      { id: "true", label: "5:00" },
      { id: "c410", label: "4:10" },
      { id: "early", label: "3:00" },
      { id: "late", label: "5:00" },
    ],
  },
  {
    id: "slow-4",
    difficulty: "medium",
    title: "Losing 5 minutes over 6 hours",
    text: "A clock loses 5 minutes every true hour. It is set right at noon. What time does it show after 6 true hours?",
    answer: "5:30.",
    accept: ["5:30", "530"],
    correct: "c530",
    options: [
      { id: "true", label: "6:00" },
      { id: "c530", label: "5:30" },
      { id: "early", label: "4:00" },
      { id: "late", label: "6:00" },
    ],
  },
  {
    id: "slow-5",
    difficulty: "medium",
    title: "Losing 5 minutes over 4 hours",
    text: "A clock loses 5 minutes every true hour. It is set right at noon. What time does it show after 4 true hours?",
    answer: "3:40.",
    accept: ["3:40", "340"],
    correct: "c340",
    options: [
      { id: "true", label: "4:00" },
      { id: "c340", label: "3:40" },
      { id: "early", label: "2:00" },
      { id: "late", label: "4:00" },
    ],
  },
  {
    id: "slow-6",
    difficulty: "medium",
    title: "Losing 15 minutes over 4 hours",
    text: "A clock loses 15 minutes every true hour. It is set right at noon. What time does it show after 4 true hours?",
    answer: "3:00.",
    accept: ["3:00", "300"],
    correct: "c300",
    options: [
      { id: "true", label: "4:00" },
      { id: "c300", label: "3:00" },
      { id: "early", label: "2:00" },
      { id: "late", label: "4:00" },
    ],
  },
  {
    id: "slow-7",
    difficulty: "medium",
    title: "Losing 15 minutes over 2 hours",
    text: "A clock loses 15 minutes every true hour. It is set right at noon. What time does it show after 2 true hours?",
    answer: "1:30.",
    accept: ["1:30", "130"],
    correct: "c130",
    options: [
      { id: "true", label: "2:00" },
      { id: "c130", label: "1:30" },
      { id: "early", label: "1:00" },
      { id: "late", label: "2:00" },
    ],
  },
  {
    id: "slow-8",
    difficulty: "medium",
    title: "Losing 20 minutes over 3 hours",
    text: "A clock loses 20 minutes every true hour. It is set right at noon. What time does it show after 3 true hours?",
    answer: "2:00.",
    accept: ["2:00", "200"],
    correct: "c200",
    options: [
      { id: "true", label: "3:00" },
      { id: "c200", label: "2:00" },
      { id: "early", label: "1:00" },
      { id: "late", label: "3:00" },
    ],
  },
  {
    id: "slow-9",
    difficulty: "medium",
    title: "Losing 12 minutes over 5 hours",
    text: "A clock loses 12 minutes every true hour. It is set right at noon. What time does it show after 5 true hours?",
    answer: "4:00.",
    accept: ["4:00", "400"],
    correct: "c400",
    options: [
      { id: "true", label: "5:00" },
      { id: "c400", label: "4:00" },
      { id: "early", label: "3:00" },
      { id: "late", label: "5:00" },
    ],
  },
  {
    id: "slow-10",
    difficulty: "medium",
    title: "Losing 6 minutes over 5 hours",
    text: "A clock loses 6 minutes every true hour. It is set right at noon. What time does it show after 5 true hours?",
    answer: "4:30.",
    accept: ["4:30", "430"],
    correct: "c430",
    options: [
      { id: "true", label: "5:00" },
      { id: "c430", label: "4:30" },
      { id: "early", label: "3:00" },
      { id: "late", label: "5:00" },
    ],
  },
  {
    id: "weight-1",
    difficulty: "hard",
    title: "The crate",
    text: "A crate of nails weighs 30 pounds together. The contents weigh twice as much as the empty crate. How many pounds is the empty crate?",
    answer: "10 pounds.",
    accept: ["10", "10 pounds", "ten"],
    correct: "10",
    options: [
      { id: "10", label: "10" },
      { id: "15", label: "15" },
      { id: "20", label: "20" },
      { id: "30", label: "30" },
    ],
  },
  {
    id: "weight-2",
    difficulty: "hard",
    title: "The keg",
    text: "A keg of oil weighs 40 pounds together. The contents weigh three times as much as the empty keg. How many pounds is the empty keg?",
    answer: "10 pounds.",
    accept: ["10", "10 pounds", "ten"],
    correct: "10",
    options: [
      { id: "10", label: "10" },
      { id: "20", label: "20" },
      { id: "30", label: "30" },
      { id: "40", label: "40" },
    ],
  },
  {
    id: "weight-3",
    difficulty: "hard",
    title: "The sack",
    text: "A sack of flour weighs 20 pounds together. The contents weigh the same as the empty sack. How many pounds is the empty sack?",
    answer: "10 pounds.",
    accept: ["10", "10 pounds", "ten"],
    correct: "10",
    options: [
      { id: "10", label: "10" },
      { id: "20", label: "20" },
    ],
  },
  {
    id: "weight-4",
    difficulty: "hard",
    title: "The box",
    text: "A box of bolts weighs 24 pounds together. The contents weigh twice as much as the empty box. How many pounds is the empty box?",
    answer: "8 pounds.",
    accept: ["8", "8 pounds", "eight"],
    correct: "8",
    options: [
      { id: "8", label: "8" },
      { id: "12", label: "12" },
      { id: "16", label: "16" },
      { id: "24", label: "24" },
    ],
  },
  {
    id: "weight-5",
    difficulty: "hard",
    title: "The tin",
    text: "A tin of paint weighs 16 pounds together. The contents weigh three times as much as the empty tin. How many pounds is the empty tin?",
    answer: "4 pounds.",
    accept: ["4", "4 pounds", "four"],
    correct: "4",
    options: [
      { id: "4", label: "4" },
      { id: "8", label: "8" },
      { id: "12", label: "12" },
      { id: "16", label: "16" },
    ],
  },
  {
    id: "weight-6",
    difficulty: "hard",
    title: "The barrel",
    text: "A barrel of tar weighs 36 pounds together. The contents weigh twice as much as the empty barrel. How many pounds is the empty barrel?",
    answer: "12 pounds.",
    accept: ["12", "12 pounds", "twelve"],
    correct: "12",
    options: [
      { id: "12", label: "12" },
      { id: "18", label: "18" },
      { id: "24", label: "24" },
      { id: "36", label: "36" },
    ],
  },
  {
    id: "weight-7",
    difficulty: "hard",
    title: "The chest",
    text: "A chest of tools weighs 28 pounds together. The contents weigh three times as much as the empty chest. How many pounds is the empty chest?",
    answer: "7 pounds.",
    accept: ["7", "7 pounds", "seven"],
    correct: "7",
    options: [
      { id: "7", label: "7" },
      { id: "14", label: "14" },
      { id: "21", label: "21" },
      { id: "28", label: "28" },
    ],
  },
  {
    id: "weight-8",
    difficulty: "hard",
    title: "The jar",
    text: "A jar of nails weighs 12 pounds together. The contents weigh twice as much as the empty jar. How many pounds is the empty jar?",
    answer: "4 pounds.",
    accept: ["4", "4 pounds", "four"],
    correct: "4",
    options: [
      { id: "4", label: "4" },
      { id: "6", label: "6" },
      { id: "8", label: "8" },
      { id: "12", label: "12" },
    ],
  },
  {
    id: "weight-9",
    difficulty: "hard",
    title: "The can",
    text: "A can of oil weighs 18 pounds together. The contents weigh twice as much as the empty can. How many pounds is the empty can?",
    answer: "6 pounds.",
    accept: ["6", "6 pounds", "six"],
    correct: "6",
    options: [
      { id: "6", label: "6" },
      { id: "9", label: "9" },
      { id: "12", label: "12" },
      { id: "18", label: "18" },
    ],
  },
  {
    id: "weight-10",
    difficulty: "hard",
    title: "The bag",
    text: "A bag of salt weighs 15 pounds together. The contents weigh twice as much as the empty bag. How many pounds is the empty bag?",
    answer: "5 pounds.",
    accept: ["5", "5 pounds", "five"],
    correct: "5",
    options: [
      { id: "5", label: "5" },
      { id: "7", label: "7" },
      { id: "10", label: "10" },
      { id: "15", label: "15" },
    ],
  },
  {
    id: "weight-11",
    difficulty: "hard",
    title: "The pot",
    text: "A pot of lead weighs 32 pounds together. The contents weigh three times as much as the empty pot. How many pounds is the empty pot?",
    answer: "8 pounds.",
    accept: ["8", "8 pounds", "eight"],
    correct: "8",
    options: [
      { id: "8", label: "8" },
      { id: "16", label: "16" },
      { id: "24", label: "24" },
      { id: "32", label: "32" },
    ],
  },
  {
    id: "weight-12",
    difficulty: "hard",
    title: "The drum",
    text: "A drum of rope weighs 48 pounds together. The contents weigh twice as much as the empty drum. How many pounds is the empty drum?",
    answer: "16 pounds.",
    accept: ["16", "16 pounds", "sixteen"],
    correct: "16",
    options: [
      { id: "16", label: "16" },
      { id: "24", label: "24" },
      { id: "32", label: "32" },
      { id: "48", label: "48" },
    ],
  },
  {
    id: "weight-13",
    difficulty: "hard",
    title: "The case",
    text: "A case of hooks weighs 21 pounds together. The contents weigh twice as much as the empty case. How many pounds is the empty case?",
    answer: "7 pounds.",
    accept: ["7", "7 pounds", "seven"],
    correct: "7",
    options: [
      { id: "7", label: "7" },
      { id: "10", label: "10" },
      { id: "14", label: "14" },
      { id: "21", label: "21" },
    ],
  },
  {
    id: "weight-14",
    difficulty: "hard",
    title: "The pail",
    text: "A pail of sand weighs 27 pounds together. The contents weigh twice as much as the empty pail. How many pounds is the empty pail?",
    answer: "9 pounds.",
    accept: ["9", "9 pounds", "nine"],
    correct: "9",
    options: [
      { id: "9", label: "9" },
      { id: "13", label: "13" },
      { id: "18", label: "18" },
      { id: "27", label: "27" },
    ],
  },
  {
    id: "weight-15",
    difficulty: "hard",
    title: "The tub",
    text: "A tub of clay weighs 20 pounds together. The contents weigh three times as much as the empty tub. How many pounds is the empty tub?",
    answer: "5 pounds.",
    accept: ["5", "5 pounds", "five"],
    correct: "5",
    options: [
      { id: "5", label: "5" },
      { id: "10", label: "10" },
      { id: "15", label: "15" },
      { id: "20", label: "20" },
    ],
  },
  {
    id: "weight-16",
    difficulty: "hard",
    title: "The bin",
    text: "A bin of coal weighs 25 pounds together. The contents weigh four times as much as the empty bin. How many pounds is the empty bin?",
    answer: "5 pounds.",
    accept: ["5", "5 pounds", "five"],
    correct: "5",
    options: [
      { id: "5", label: "5" },
      { id: "12", label: "12" },
      { id: "20", label: "20" },
      { id: "25", label: "25" },
    ],
  },
  {
    id: "rate-1",
    difficulty: "hard",
    title: "Pump 1",
    text: "A pump fills a tank in 4 hours. A leak empties a full tank in 12 hours. The pump runs while the leak stays open. How many hours to fill the tank?",
    answer: "6 hours.",
    accept: ["6", "6 hours", "six"],
    correct: "6",
    options: [
      { id: "4", label: "4" },
      { id: "6", label: "6" },
      { id: "12", label: "12" },
      { id: "16", label: "16" },
    ],
  },
  {
    id: "rate-2",
    difficulty: "hard",
    title: "Pump 2",
    text: "A pump fills a tank in 3 hours. A leak empties a full tank in 6 hours. The pump runs while the leak stays open. How many hours to fill the tank?",
    answer: "6 hours.",
    accept: ["6", "6 hours", "six"],
    correct: "6",
    options: [
      { id: "3", label: "3" },
      { id: "6", label: "6" },
      { id: "9", label: "9" },
    ],
  },
  {
    id: "rate-3",
    difficulty: "hard",
    title: "Pump 3",
    text: "A pump fills a tank in 6 hours. A leak empties a full tank in 12 hours. The pump runs while the leak stays open. How many hours to fill the tank?",
    answer: "12 hours.",
    accept: ["12", "12 hours", "twelve"],
    correct: "12",
    options: [
      { id: "6", label: "6" },
      { id: "12", label: "12" },
      { id: "18", label: "18" },
    ],
  },
  {
    id: "rate-4",
    difficulty: "hard",
    title: "Pump 4",
    text: "A pump fills a tank in 8 hours. A leak empties a full tank in 24 hours. The pump runs while the leak stays open. How many hours to fill the tank?",
    answer: "12 hours.",
    accept: ["12", "12 hours", "twelve"],
    correct: "12",
    options: [
      { id: "8", label: "8" },
      { id: "12", label: "12" },
      { id: "24", label: "24" },
      { id: "32", label: "32" },
    ],
  },
  {
    id: "rate-5",
    difficulty: "hard",
    title: "Pump 5",
    text: "A pump fills a tank in 2 hours. A leak empties a full tank in 6 hours. The pump runs while the leak stays open. How many hours to fill the tank?",
    answer: "3 hours.",
    accept: ["3", "3 hours", "three"],
    correct: "3",
    options: [
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "6", label: "6" },
      { id: "8", label: "8" },
    ],
  },
  {
    id: "rate-6",
    difficulty: "hard",
    title: "Pump 6",
    text: "A pump fills a tank in 6 hours. A leak empties a full tank in 18 hours. The pump runs while the leak stays open. How many hours to fill the tank?",
    answer: "9 hours.",
    accept: ["9", "9 hours", "nine"],
    correct: "9",
    options: [
      { id: "6", label: "6" },
      { id: "9", label: "9" },
      { id: "18", label: "18" },
      { id: "24", label: "24" },
    ],
  },
  {
    id: "rate-7",
    difficulty: "hard",
    title: "Pump 7",
    text: "A pump fills a tank in 3 hours. A leak empties a full tank in 12 hours. The pump runs while the leak stays open. How many hours to fill the tank?",
    answer: "4 hours.",
    accept: ["4", "4 hours", "four"],
    correct: "4",
    options: [
      { id: "3", label: "3" },
      { id: "4", label: "4" },
      { id: "12", label: "12" },
      { id: "15", label: "15" },
    ],
  },
  {
    id: "rate-8",
    difficulty: "hard",
    title: "Pump 8",
    text: "A pump fills a tank in 4 hours. A leak empties a full tank in 20 hours. The pump runs while the leak stays open. How many hours to fill the tank?",
    answer: "5 hours.",
    accept: ["5", "5 hours", "five"],
    correct: "5",
    options: [
      { id: "4", label: "4" },
      { id: "5", label: "5" },
      { id: "20", label: "20" },
      { id: "24", label: "24" },
    ],
  },
  {
    id: "rate-9",
    difficulty: "hard",
    title: "Pump 9",
    text: "A pump fills a tank in 4 hours. A leak empties a full tank in 6 hours. The pump runs while the leak stays open. How many hours to fill the tank?",
    answer: "12 hours.",
    accept: ["12", "12 hours", "twelve"],
    correct: "12",
    options: [
      { id: "4", label: "4" },
      { id: "6", label: "6" },
      { id: "10", label: "10" },
      { id: "12", label: "12" },
    ],
  },
  {
    id: "rate-10",
    difficulty: "hard",
    title: "Pump 10",
    text: "A pump fills a tank in 8 hours. A leak empties a full tank in 12 hours. The pump runs while the leak stays open. How many hours to fill the tank?",
    answer: "24 hours.",
    accept: ["24", "24 hours", "twenty-four"],
    correct: "24",
    options: [
      { id: "8", label: "8" },
      { id: "12", label: "12" },
      { id: "20", label: "20" },
      { id: "24", label: "24" },
    ],
  },
  {
    id: "rate-11",
    difficulty: "hard",
    title: "Pump 11",
    text: "A pump fills a tank in 10 hours. A leak empties a full tank in 15 hours. The pump runs while the leak stays open. How many hours to fill the tank?",
    answer: "30 hours.",
    accept: ["30", "30 hours", "thirty"],
    correct: "30",
    options: [
      { id: "10", label: "10" },
      { id: "15", label: "15" },
      { id: "25", label: "25" },
      { id: "30", label: "30" },
    ],
  },
  {
    id: "rate-12",
    difficulty: "hard",
    title: "Pump 12",
    text: "A pump fills a tank in 9 hours. A leak empties a full tank in 18 hours. The pump runs while the leak stays open. How many hours to fill the tank?",
    answer: "18 hours.",
    accept: ["18", "18 hours", "eighteen"],
    correct: "18",
    options: [
      { id: "9", label: "9" },
      { id: "18", label: "18" },
      { id: "27", label: "27" },
    ],
  },
  {
    id: "candle-1",
    difficulty: "hard",
    title: "Candles 3 and 5",
    text: "One candle burns for 3 hours. The other burns for 5 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "2 hours.",
    accept: ["2", "2 hours", "two"],
    correct: "2",
    options: [
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "5", label: "5" },
      { id: "8", label: "8" },
    ],
  },
  {
    id: "candle-2",
    difficulty: "hard",
    title: "Candles 4 and 7",
    text: "One candle burns for 4 hours. The other burns for 7 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "3 hours.",
    accept: ["3", "3 hours", "three"],
    correct: "3",
    options: [
      { id: "3", label: "3" },
      { id: "4", label: "4" },
      { id: "7", label: "7" },
      { id: "11", label: "11" },
    ],
  },
  {
    id: "candle-3",
    difficulty: "hard",
    title: "Candles 2 and 5",
    text: "One candle burns for 2 hours. The other burns for 5 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "3 hours.",
    accept: ["3", "3 hours", "three"],
    correct: "3",
    options: [
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "5", label: "5" },
      { id: "7", label: "7" },
    ],
  },
  {
    id: "candle-4",
    difficulty: "hard",
    title: "Candles 5 and 8",
    text: "One candle burns for 5 hours. The other burns for 8 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "3 hours.",
    accept: ["3", "3 hours", "three"],
    correct: "3",
    options: [
      { id: "3", label: "3" },
      { id: "5", label: "5" },
      { id: "8", label: "8" },
      { id: "13", label: "13" },
    ],
  },
  {
    id: "candle-5",
    difficulty: "hard",
    title: "Candles 6 and 9",
    text: "One candle burns for 6 hours. The other burns for 9 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "3 hours.",
    accept: ["3", "3 hours", "three"],
    correct: "3",
    options: [
      { id: "3", label: "3" },
      { id: "6", label: "6" },
      { id: "9", label: "9" },
      { id: "15", label: "15" },
    ],
  },
  {
    id: "candle-6",
    difficulty: "hard",
    title: "Candles 3 and 8",
    text: "One candle burns for 3 hours. The other burns for 8 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "5 hours.",
    accept: ["5", "5 hours", "five"],
    correct: "5",
    options: [
      { id: "3", label: "3" },
      { id: "5", label: "5" },
      { id: "8", label: "8" },
      { id: "11", label: "11" },
    ],
  },
  {
    id: "candle-7",
    difficulty: "hard",
    title: "Candles 4 and 9",
    text: "One candle burns for 4 hours. The other burns for 9 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "5 hours.",
    accept: ["5", "5 hours", "five"],
    correct: "5",
    options: [
      { id: "4", label: "4" },
      { id: "5", label: "5" },
      { id: "9", label: "9" },
      { id: "13", label: "13" },
    ],
  },
  {
    id: "candle-8",
    difficulty: "hard",
    title: "Candles 2 and 6",
    text: "One candle burns for 2 hours. The other burns for 6 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "4 hours.",
    accept: ["4", "4 hours", "four"],
    correct: "4",
    options: [
      { id: "2", label: "2" },
      { id: "4", label: "4" },
      { id: "6", label: "6" },
      { id: "8", label: "8" },
    ],
  },
  {
    id: "candle-9",
    difficulty: "hard",
    title: "Candles 5 and 9",
    text: "One candle burns for 5 hours. The other burns for 9 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "4 hours.",
    accept: ["4", "4 hours", "four"],
    correct: "4",
    options: [
      { id: "4", label: "4" },
      { id: "5", label: "5" },
      { id: "9", label: "9" },
      { id: "14", label: "14" },
    ],
  },
  {
    id: "candle-10",
    difficulty: "hard",
    title: "Candles 1 and 4",
    text: "One candle burns for 1 hours. The other burns for 4 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "3 hours.",
    accept: ["3", "3 hours", "three"],
    correct: "3",
    options: [
      { id: "1", label: "1" },
      { id: "3", label: "3" },
      { id: "4", label: "4" },
      { id: "5", label: "5" },
    ],
  },
  {
    id: "candle-11",
    difficulty: "hard",
    title: "Candles 6 and 10",
    text: "One candle burns for 6 hours. The other burns for 10 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "4 hours.",
    accept: ["4", "4 hours", "four"],
    correct: "4",
    options: [
      { id: "4", label: "4" },
      { id: "6", label: "6" },
      { id: "10", label: "10" },
      { id: "16", label: "16" },
    ],
  },
  {
    id: "candle-12",
    difficulty: "hard",
    title: "Candles 3 and 6",
    text: "One candle burns for 3 hours. The other burns for 6 hours. You light them together. When the short candle goes out, how long can the tall candle still burn?",
    answer: "3 hours.",
    accept: ["3", "3 hours", "three"],
    correct: "3",
    options: [
      { id: "3", label: "3" },
      { id: "6", label: "6" },
      { id: "9", label: "9" },
    ],
  },
  {
    id: "wage-1",
    difficulty: "hard",
    title: "4 days paid as 12 coins",
    text: "4 days' wages are 12 coins. The same days can be paid as 2 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "1 coin.",
    accept: ["1", "1 coin", "1 coins", "one"],
    correct: "1",
    options: [
      { id: "1", label: "1" },
      { id: "2", label: "2" },
      { id: "3", label: "3" },
    ],
  },
  {
    id: "wage-2",
    difficulty: "hard",
    title: "3 days paid as 12 coins",
    text: "3 days' wages are 12 coins. The same days can be paid as 2 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "2 coins.",
    accept: ["2", "2 coin", "2 coins", "two"],
    correct: "2",
    options: [
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "wage-3",
    difficulty: "hard",
    title: "5 days paid as 20 coins",
    text: "5 days' wages are 20 coins. The same days can be paid as 3 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "1 coin.",
    accept: ["1", "1 coin", "1 coins", "one"],
    correct: "1",
    options: [
      { id: "1", label: "1" },
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "wage-4",
    difficulty: "hard",
    title: "4 days paid as 16 coins",
    text: "4 days' wages are 16 coins. The same days can be paid as 3 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "1 coin.",
    accept: ["1", "1 coin", "1 coins", "one"],
    correct: "1",
    options: [
      { id: "1", label: "1" },
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "wage-5",
    difficulty: "hard",
    title: "6 days paid as 18 coins",
    text: "6 days' wages are 18 coins. The same days can be paid as 2 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "1 coin.",
    accept: ["1", "1 coin", "1 coins", "one"],
    correct: "1",
    options: [
      { id: "1", label: "1" },
      { id: "2", label: "2" },
      { id: "3", label: "3" },
    ],
  },
  {
    id: "wage-6",
    difficulty: "hard",
    title: "2 days paid as 10 coins",
    text: "2 days' wages are 10 coins. The same days can be paid as 3 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "2 coins.",
    accept: ["2", "2 coin", "2 coins", "two"],
    correct: "2",
    options: [
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "5", label: "5" },
    ],
  },
  {
    id: "wage-7",
    difficulty: "hard",
    title: "3 days paid as 15 coins",
    text: "3 days' wages are 15 coins. The same days can be paid as 4 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "1 coin.",
    accept: ["1", "1 coin", "1 coins", "one"],
    correct: "1",
    options: [
      { id: "1", label: "1" },
      { id: "2", label: "2" },
      { id: "4", label: "4" },
      { id: "5", label: "5" },
    ],
  },
  {
    id: "wage-8",
    difficulty: "hard",
    title: "4 days paid as 20 coins",
    text: "4 days' wages are 20 coins. The same days can be paid as 3 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "2 coins.",
    accept: ["2", "2 coin", "2 coins", "two"],
    correct: "2",
    options: [
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "5", label: "5" },
    ],
  },
  {
    id: "wage-9",
    difficulty: "hard",
    title: "5 days paid as 15 coins",
    text: "5 days' wages are 15 coins. The same days can be paid as 2 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "1 coin.",
    accept: ["1", "1 coin", "1 coins", "one"],
    correct: "1",
    options: [
      { id: "1", label: "1" },
      { id: "2", label: "2" },
      { id: "3", label: "3" },
    ],
  },
  {
    id: "wage-10",
    difficulty: "hard",
    title: "6 days paid as 24 coins",
    text: "6 days' wages are 24 coins. The same days can be paid as 3 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "1 coin.",
    accept: ["1", "1 coin", "1 coins", "one"],
    correct: "1",
    options: [
      { id: "1", label: "1" },
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "wage-11",
    difficulty: "hard",
    title: "2 days paid as 8 coins",
    text: "2 days' wages are 8 coins. The same days can be paid as 2 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "2 coins.",
    accept: ["2", "2 coin", "2 coins", "two"],
    correct: "2",
    options: [
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "wage-12",
    difficulty: "hard",
    title: "8 days paid as 24 coins",
    text: "8 days' wages are 24 coins. The same days can be paid as 2 coins and a meal each day, and the two deals are equal. What is a meal worth?",
    answer: "1 coin.",
    accept: ["1", "1 coin", "1 coins", "one"],
    correct: "1",
    options: [
      { id: "1", label: "1" },
      { id: "2", label: "2" },
      { id: "3", label: "3" },
    ],
  },
  {
    id: "part-generator",
    difficulty: "hard",
    title: "The generator tank",
    text: "A full tank runs the generator for 8 hours. The tank is half full. How long will the generator run?",
    answer: "4 hours.",
    accept: ["4", "4 hours", "four"],
    correct: "4",
    options: [
      { id: "4", label: "4" },
      { id: "5", label: "5" },
      { id: "8", label: "8" },
    ],
  },
  {
    id: "part-lamp",
    difficulty: "hard",
    title: "The lamp tank",
    text: "A full tank runs the lamp for 6 hours. The tank is half full. How long will the lamp run?",
    answer: "3 hours.",
    accept: ["3", "3 hours", "three"],
    correct: "3",
    options: [
      { id: "3", label: "3" },
      { id: "4", label: "4" },
      { id: "6", label: "6" },
    ],
  },
  {
    id: "part-stove",
    difficulty: "hard",
    title: "The stove tank",
    text: "A full tank runs the stove for 12 hours. The tank is one third full. How long will the stove run?",
    answer: "4 hours.",
    accept: ["4", "4 hours", "four"],
    correct: "4",
    options: [
      { id: "4", label: "4" },
      { id: "8", label: "8" },
      { id: "12", label: "12" },
    ],
  },
  {
    id: "part-pump",
    difficulty: "hard",
    title: "The pump tank",
    text: "A full tank runs the pump for 9 hours. The tank is one third full. How long will the pump run?",
    answer: "3 hours.",
    accept: ["3", "3 hours", "three"],
    correct: "3",
    options: [
      { id: "3", label: "3" },
      { id: "6", label: "6" },
      { id: "9", label: "9" },
    ],
  },
  {
    id: "part-winch",
    difficulty: "hard",
    title: "The winch tank",
    text: "A full tank runs the winch for 10 hours. The tank is half full. How long will the winch run?",
    answer: "5 hours.",
    accept: ["5", "5 hours", "five"],
    correct: "5",
    options: [
      { id: "5", label: "5" },
      { id: "6", label: "6" },
      { id: "10", label: "10" },
    ],
  },
  {
    id: "part-heater",
    difficulty: "hard",
    title: "The heater tank",
    text: "A full tank runs the heater for 4 hours. The tank is half full. How long will the heater run?",
    answer: "2 hours.",
    accept: ["2", "2 hours", "two"],
    correct: "2",
    options: [
      { id: "2", label: "2" },
      { id: "3", label: "3" },
      { id: "4", label: "4" },
    ],
  },
  {
    id: "part-radio",
    difficulty: "hard",
    title: "The radio tank",
    text: "A full tank runs the radio for 16 hours. The tank is one quarter full. How long will the radio run?",
    answer: "4 hours.",
    accept: ["4", "4 hours", "four"],
    correct: "4",
    options: [
      { id: "4", label: "4" },
      { id: "8", label: "8" },
      { id: "12", label: "12" },
      { id: "16", label: "16" },
    ],
  },
  {
    id: "part-fan",
    difficulty: "hard",
    title: "The fan tank",
    text: "A full tank runs the fan for 12 hours. The tank is one quarter full. How long will the fan run?",
    answer: "3 hours.",
    accept: ["3", "3 hours", "three"],
    correct: "3",
    options: [
      { id: "3", label: "3" },
      { id: "6", label: "6" },
      { id: "9", label: "9" },
      { id: "12", label: "12" },
    ],
  },
  {
    id: "part-boiler",
    difficulty: "hard",
    title: "The boiler tank",
    text: "A full tank runs the boiler for 18 hours. The tank is one third full. How long will the boiler run?",
    answer: "6 hours.",
    accept: ["6", "6 hours", "six"],
    correct: "6",
    options: [
      { id: "6", label: "6" },
      { id: "12", label: "12" },
      { id: "18", label: "18" },
    ],
  },
  {
    id: "part-engine",
    difficulty: "hard",
    title: "The engine tank",
    text: "A full tank runs the engine for 20 hours. The tank is one quarter full. How long will the engine run?",
    answer: "5 hours.",
    accept: ["5", "5 hours", "five"],
    correct: "5",
    options: [
      { id: "5", label: "5" },
      { id: "10", label: "10" },
      { id: "15", label: "15" },
      { id: "20", label: "20" },
    ],
  },
  {
    id: "part-dryer",
    difficulty: "hard",
    title: "The dryer tank",
    text: "A full tank runs the dryer for 15 hours. The tank is one third full. How long will the dryer run?",
    answer: "5 hours.",
    accept: ["5", "5 hours", "five"],
    correct: "5",
    options: [
      { id: "5", label: "5" },
      { id: "10", label: "10" },
      { id: "15", label: "15" },
    ],
  },
  {
    id: "part-light",
    difficulty: "hard",
    title: "The light tank",
    text: "A full tank runs the light for 14 hours. The tank is half full. How long will the light run?",
    answer: "7 hours.",
    accept: ["7", "7 hours", "seven"],
    correct: "7",
    options: [
      { id: "7", label: "7" },
      { id: "8", label: "8" },
      { id: "14", label: "14" },
    ],
  },
  {
    id: "posts-a",
    difficulty: "hard",
    title: "The morning bell",
    text: "Ned, Ruth, and Sol take the morning, noon, and night bells, one each. Sol takes neither morning nor night. Ned does not take morning. Who takes the night bell?",
    answer: "Ned.",
    accept: ["ned", "ned"],
    correct: "ned",
    options: [
      { id: "ned", label: "Ned" },
      { id: "ruth", label: "Ruth" },
      { id: "sol", label: "Sol" },
    ],
  },
  {
    id: "posts-b",
    difficulty: "hard",
    title: "The quay watch",
    text: "Ann, Bo, and Clem take the first, second, and third watch, one each. Bo takes neither first nor third. Ann does not take first. Who takes the third watch?",
    answer: "Ann.",
    accept: ["ann", "ann"],
    correct: "ann",
    options: [
      { id: "ann", label: "Ann" },
      { id: "bo", label: "Bo" },
      { id: "clem", label: "Clem" },
    ],
  },
  {
    id: "posts-c",
    difficulty: "hard",
    title: "The lamp round",
    text: "Di, Ed, and Flo take the early, middle, and late lamp round, one each. Ed takes neither early nor late. Di does not take early. Who takes the late round?",
    answer: "Di.",
    accept: ["di", "di"],
    correct: "di",
    options: [
      { id: "di", label: "Di" },
      { id: "ed", label: "Ed" },
      { id: "flo", label: "Flo" },
    ],
  },
  {
    id: "posts-d",
    difficulty: "hard",
    title: "The gate keys",
    text: "Gil, Hett, and Ian hold the yard key, the shed key, and the pier key, one each. Ian holds neither the yard key nor the pier key. Gil does not hold the yard key. Who holds the pier key?",
    answer: "Gil.",
    accept: ["gil", "gil"],
    correct: "gil",
    options: [
      { id: "gil", label: "Gil" },
      { id: "hett", label: "Hett" },
      { id: "ian", label: "Ian" },
    ],
  },
  {
    id: "posts-e",
    difficulty: "hard",
    title: "The three oars",
    text: "Jo, Kit, and Len take the bow oar, the mid oar, and the stroke oar, one each. Kit takes neither bow nor stroke. Jo does not take the bow. Who takes the stroke oar?",
    answer: "Jo.",
    accept: ["jo", "jo"],
    correct: "jo",
    options: [
      { id: "jo", label: "Jo" },
      { id: "kit", label: "Kit" },
      { id: "len", label: "Len" },
    ],
  },
  {
    id: "posts-f",
    difficulty: "hard",
    title: "The soup pots",
    text: "Mae, Ned, and Opal carry the small pot, the mid pot, and the large pot, one each. Ned carries neither the small pot nor the large pot. Mae does not carry the small pot. Who carries the large pot?",
    answer: "Mae.",
    accept: ["mae", "mae"],
    correct: "mae",
    options: [
      { id: "mae", label: "Mae" },
      { id: "ned", label: "Ned" },
      { id: "opal", label: "Opal" },
    ],
  },
  {
    id: "posts-g",
    difficulty: "hard",
    title: "The chart pencils",
    text: "Pip, Quin, and Rea use the red pencil, the blue pencil, and the black pencil, one each. Quin uses neither red nor black. Pip does not use red. Who uses the black pencil?",
    answer: "Pip.",
    accept: ["pip", "pip"],
    correct: "pip",
    options: [
      { id: "pip", label: "Pip" },
      { id: "quin", label: "Quin" },
      { id: "rea", label: "Rea" },
    ],
  },
  {
    id: "posts-h",
    difficulty: "hard",
    title: "The night coats",
    text: "Sue, Tam, and Una take the short coat, the mid coat, and the long coat, one each. Tam takes neither the short coat nor the long coat. Sue does not take the short coat. Who takes the long coat?",
    answer: "Sue.",
    accept: ["sue", "sue"],
    correct: "sue",
    options: [
      { id: "sue", label: "Sue" },
      { id: "tam", label: "Tam" },
      { id: "una", label: "Una" },
    ],
  },
];

function mulberry32(seed) {
  let a = seed >>> 0;
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function caseLabel(seed) {
  return (seed >>> 0).toString(16).padStart(8, "0");
}

function foldTight(value) {
  return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, "");
}

function riddleById(id) {
  for (let i = 0; i < SLIPS.length; i++) if (SLIPS[i].id === id) return SLIPS[i];
  return null;
}

function shuffle(list, rand) {
  const copy = list.slice();
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    const tmp = copy[i];
    copy[i] = copy[j];
    copy[j] = tmp;
  }
  return copy;
}

function idsByDifficulty(difficulty) {
  return SLIPS.filter(function (slip) { return slip.difficulty === difficulty; }).map(function (slip) { return slip.id; });
}

function createCase(seed) {
  const rand = mulberry32(seed >>> 0);
  const picked = []
    .concat(shuffle(idsByDifficulty("easy"), rand).slice(0, 4))
    .concat(shuffle(idsByDifficulty("medium"), rand).slice(0, 4))
    .concat(shuffle(idsByDifficulty("hard"), rand).slice(0, 4));
  return { version: 1, seed: seed >>> 0, slips: shuffle(picked, rand) };
}

function accepts(slip, raw) {
  const found = typeof slip === "string" ? riddleById(slip) : slip;
  if (!found) return false;
  const got = foldTight(raw);
  if (!got) return false;
  return found.accept.some(function (item) { return foldTight(item) === got; });
}

function isCorrect(slip, optionId) {
  const found = typeof slip === "string" ? riddleById(slip) : slip;
  return Boolean(found) && found.correct === optionId;
}

function optionOrder(slip, seed) {
  const found = typeof slip === "string" ? riddleById(slip) : slip;
  let mix = seed >>> 0;
  for (let i = 0; i < found.id.length; i++) mix = (Math.imul(mix, 33) ^ found.id.charCodeAt(i)) >>> 0;
  return shuffle(found.options, mulberry32(mix || 1));
}

function assertCase(state) {
  if (!state || state.version !== 1 || !Array.isArray(state.slips) || state.slips.length !== 12) {
    throw new Error("The set is incomplete");
  }
  const seen = {};
  const counts = { easy: 0, medium: 0, hard: 0 };
  state.slips.forEach(function (id) {
    const slip = riddleById(id);
    if (!slip || seen[id]) throw new Error("The set repeats a riddle");
    seen[id] = true;
    counts[slip.difficulty] += 1;
  });
  if (counts.easy !== 4 || counts.medium !== 4 || counts.hard !== 4) throw new Error("The set is unbalanced");
  const again = createCase(state.seed);
  for (let i = 0; i < 12; i++) if (again.slips[i] !== state.slips[i]) throw new Error("The set is not fixed");
  const blob = JSON.stringify(SLIPS);
  if (/cluedo|murdle|holmes|watson|moriarty|jawbone|journal 29|alice|starling|wordle/i.test(blob)) {
    throw new Error("Reserved wording");
  }
}

function runSelfTest() {
  if (SLIPS.length !== 240) throw new Error("The box should hold 240 riddles");
  for (let seed = 1; seed <= 12; seed++) assertCase(createCase(seed));
  if (!accepts("clock", "5:00")) throw new Error("Clock should match");
  if (accepts("hook", "second")) throw new Error("Second hook is wrong");
  if (!accepts("tin", "2 hours and 40 minutes")) throw new Error("Tin should match");
  SLIPS.forEach(function (slip) {
    if (!slip.options || slip.options.length < 2) throw new Error(slip.id + " needs choices");
    const seen = {};
    slip.options.forEach(function (option) {
      if (!option.id || !option.label || seen[option.id]) throw new Error(slip.id + " has a bad choice");
      seen[option.id] = true;
    });
    if (!seen[slip.correct]) throw new Error(slip.id + " has no right choice");
    const ordered = optionOrder(slip, 3);
    if (ordered.length !== slip.options.length) throw new Error(slip.id + " lost a choice");
    ordered.forEach(function (option) { if (!seen[option.id]) throw new Error(slip.id + " invented a choice"); });
    if (!isCorrect(slip, slip.correct)) throw new Error(slip.id + " should accept its right choice");
    const wrong = slip.options.filter(function (option) { return option.id !== slip.correct; })[0];
    if (isCorrect(slip, wrong.id)) throw new Error(slip.id + " should refuse a wrong choice");
  });
  const summary = "riddle box deck 240 seed1 " + caseLabel(1);
  if (typeof print === "function") print(summary);
  else console.log(summary);
}

if (typeof window === "undefined") runSelfTest();

globalThis.RiddleBox = {
  TITLE: TITLE,
  DEK: DEK,
  introParagraphs: introParagraphs,
  SLIPS: SLIPS,
  caseLabel: caseLabel,
  foldTight: foldTight,
  riddleById: riddleById,
  createCase: createCase,
  accepts: accepts,
  isCorrect: isCorrect,
  optionOrder: optionOrder,
  assertCase: assertCase,
};
